webpackJsonp([1],{

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.8218f86.jpg";

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ChangePassword__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ChangePassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ChangePassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mainview__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_mainview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_mainview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_testEdit__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_testEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_testEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_results__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_results___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_results__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_managementCenter__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_managementCenter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_managementCenter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_managementTeacher__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_managementTeacher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_managementTeacher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_managementDiscipline__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_managementDiscipline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_managementDiscipline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_recoverPassword__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_recoverPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_recoverPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_managementKnowledge__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_managementKnowledge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_managementKnowledge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_bareme__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_bareme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_bareme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_managementStudentsGroups__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_managementStudentsGroups___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_managementStudentsGroups__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_myAccount__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_myAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_myAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_support__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_support___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_support__);

















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var api = '';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Login___default.a,
    props: { api: api }
  }, {
    path: '/changePassword',
    name: 'ChangePassword',
    component: __WEBPACK_IMPORTED_MODULE_3__components_ChangePassword___default.a
  }, {
    path: '/mainview',
    name: 'mainview',
    component: __WEBPACK_IMPORTED_MODULE_4__components_mainview___default.a
  }, {
    path: '/testEdit/:testId',
    name: 'testEdit',
    component: __WEBPACK_IMPORTED_MODULE_5__components_testEdit___default.a
  }, {
    path: '/results/:testId',
    name: 'results',
    component: __WEBPACK_IMPORTED_MODULE_6__components_results___default.a
  }, {
    path: '/managementCenter',
    name: 'managementCenter',
    component: __WEBPACK_IMPORTED_MODULE_7__components_managementCenter___default.a
  }, {
    path: '/managementTeacher',
    name: 'managementTeacher',
    component: __WEBPACK_IMPORTED_MODULE_8__components_managementTeacher___default.a
  }, {
    path: '/managementDiscipline',
    name: 'managementDiscipline',
    component: __WEBPACK_IMPORTED_MODULE_9__components_managementDiscipline___default.a
  }, {
    path: '/recoverPassword',
    name: 'recoverPassword',
    component: __WEBPACK_IMPORTED_MODULE_10__components_recoverPassword___default.a
  }, {
    path: '/managementKnowledge/:testId',
    name: 'managementKnowledge',
    component: __WEBPACK_IMPORTED_MODULE_11__components_managementKnowledge___default.a
  }, {
    path: '/bareme/:testId',
    name: 'bareme',
    component: __WEBPACK_IMPORTED_MODULE_12__components_bareme___default.a
  }, {
    path: '/managementStudentsGroups',
    name: 'managementStudentsGroups',
    component: __WEBPACK_IMPORTED_MODULE_13__components_managementStudentsGroups___default.a
  }, {
    path: '/myAccount',
    name: 'myAccount',
    component: __WEBPACK_IMPORTED_MODULE_14__components_myAccount___default.a
  }, {
    path: '/support',
    name: 'support',
    component: __WEBPACK_IMPORTED_MODULE_15__components_support___default.a
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
}));

/***/ }),

/***/ 391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var state = {
  api: 'backend/',
  changePassword: true,
  fullname: '',
  lang: 'fr',
  title: '',
  token: null,
  adminLevel: 0,
  licence: 0
};

if (typeof localStorage.getItem('lang') !== 'undefined') {
  var temp = localStorage.getItem('lang');
  if (temp === null) {
    localStorage.setItem('lang', state.lang);
  } else {
    state.lang = temp;
  }
} else {
  localStorage.setItem('lang', state.lang);
}

var getters = {
  isAuthenticated: function isAuthenticated(state) {
    return state.token != null;
  },
  needPasswordChange: function needPasswordChange(state) {
    return state.changePassword === true;
  },
  adminLevel: function adminLevel(state) {
    return state.adminLevel;
  },
  licence: function licence(state) {
    return state.licence;
  }
};

var mutations = {
  AUTHENTICATE: function AUTHENTICATE(state, obj) {
    if (typeof obj.changePassword !== 'undefined') {
      state.changePassword = obj.changePassword;
      sessionStorage.setItem('changePassword', obj.changePassword);
    }
    if (typeof obj.fullname !== 'undefined') {
      state.fullname = obj.fullname;
      sessionStorage.setItem('fullname', obj.fullname);
    }
    if (typeof obj.token !== 'undefined') {
      state.token = obj.token;
      sessionStorage.setItem('token', obj.token);
    }
    if (typeof obj.adminLevel !== 'undefined') {
      state.adminLevel = obj.adminLevel;
      sessionStorage.setItem('adminLevel', obj.adminLevel);
    }
    if (typeof obj.licence !== 'undefined') {
      state.licence = obj.licence;
      sessionStorage.setItem('licence', obj.licence);
    }
  },
  LOGOUT: function LOGOUT(state) {
    state.changePassword = true;
    state.fullname = '';
    state.token = null;
    sessionStorage.removeItem('fullname');
    sessionStorage.removeItem('token');
    state.adminLevel = 0;
    state.licence = 0;
  },
  LANGUAGE: function LANGUAGE(state, lang) {
    if (typeof lang !== 'undefined') {
      state.lang = lang;
      localStorage.setItem('lang', lang);
    }
    console.log('DEBUG' + state.lang);
  },
  UPDATE_TITLE: function UPDATE_TITLE(state, title) {
    state.title = title;
  }
};

var actions = {};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
  strict: "production" !== 'production'
}));

/***/ }),

/***/ 399:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 400:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(798)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(873),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_promise_client_core_promise_js__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_promise_client_core_promise_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_promise_client_core_promise_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es5_shim_es5_shim_min_js__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es5_shim_es5_shim_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_es5_shim_es5_shim_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_es5_shim_es5_sham_min_js__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_es5_shim_es5_sham_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_es5_shim_es5_sham_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html5shiv__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html5shiv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_html5shiv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_es6_promise_auto__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_polyfill__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_es6_shim_es6_shim_min_js__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_es6_shim_es6_shim_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_es6_shim_es6_shim_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_es6_shim_es6_sham_min_js__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_es6_shim_es6_sham_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_es6_shim_es6_sham_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_i18n__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_axios__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__vuex_store__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_tables_2__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_bootstrap_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_bootstrap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_bootstrap_vue__);















__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_i18n___default.a);





__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_13_axios___default.a);





__WEBPACK_IMPORTED_MODULE_9_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].config.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'fr';

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(locales).forEach(function (lang) {
  __WEBPACK_IMPORTED_MODULE_9_vue__["default"].locale(lang, locales[lang]);
});

window.Cookies = __webpack_require__(402);
window.md5 = __webpack_require__(403);

__webpack_require__(400);

__webpack_require__(399);


__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_bootstrap_vue___default.a);

__WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.path !== '/' && to.path !== '/login' && to.path !== '/recoverPassword') {
    if (!__WEBPACK_IMPORTED_MODULE_15__vuex_store__["a" /* default */].getters.isAuthenticated) {
      __WEBPACK_IMPORTED_MODULE_15__vuex_store__["a" /* default */].commit('LOGOUT');

      next('/');
    } else {
      next();
    }
  } else {
    if (__WEBPACK_IMPORTED_MODULE_15__vuex_store__["a" /* default */].getters.isAuthenticated) {
      next('/mainview');
    } else {
      next();
    }
  }
});

__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_tables_2___default.a.ClientTable, {
  sortIcon: {
    base: 'fa',
    up: 'fa-angle-up',
    down: 'fa-angle-up',
    is: 'fa-angle-up'
  },
  theme: 'bootstrap4'
});

new __WEBPACK_IMPORTED_MODULE_9_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_15__vuex_store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_10__App___default.a }
});

/***/ }),

/***/ 435:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_simple_spinner__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_simple_spinner__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    BootstrapVue: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue___default.a,
    spinner: __WEBPACK_IMPORTED_MODULE_3_vue_simple_spinner___default.a
  },
  data: function data() {
    return {
      spinner: false,
      isSideBarVisible: false,
      tableTexts: {
        count: this.$t('LNG_TABLE_COUNT', this.lang),
        filter: this.$t('LNG_TABLE_FILTER', this.lang),
        filterPlaceholder: this.$t('LNG_TABLE_FILTERPLACEHOLDER', this.lang),
        limit: this.$t('LNG_TABLE_LIMIT', this.lang),
        noResults: this.$t('LNG_TABLE_NORESULTS', this.lang),
        page: this.$t('LNG_TABLE_PAGE', this.lang),
        filterBy: this.$t('LNG_TABLE_FILTERBY', this.lang),
        loading: this.$t('LNG_TABLE_LOADING', this.lang),
        defaultOption: this.$t('LNG_TABLE_DEFAULTOPTION', this.lang)
      }
    };
  },
  mounted: function mounted() {
    this.$store.commit('UPDATE_TITLE', this.$t('LNG_TITLE', this.lang));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    adminLevel: function adminLevel() {
      return this.$store.getters.adminLevel;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['api', 'lang', 'title', 'fullname'])),
  methods: {
    logout: function logout() {
      this.$store.commit('LOGOUT');
      this.$router.push({ path: '/' });
    },

    gotoManagementTeacher: function gotoManagementTeacher() {
      this.$router.push({ path: '/managementTeacher' });
    },
    gotoManagementDiscipline: function gotoManagementDiscipline() {
      this.$router.push({ path: '/ManagementDiscipline' });
    },
    gotoManagementCenter: function gotoManagementCenter() {
      this.$router.push({ path: '/ManagementCenter' });
    },
    gotoShowModal: function gotoShowModal() {
      this.$refs.childApplication.openFileModelStudents();
    },

    importObjectives: function importObjectives(event) {
      this.$refs.childApplication.importObjectivesMenu(event);
    },
    uploadFile: function uploadFile() {
      this.$refs.childApplication.uploadFileMenu();
    },
    enterResultsMenu: function enterResultsMenu() {
      this.$refs.childApplication.enterResultsMenu();
    },
    printReport: function printReport() {
      this.$refs.childApplication.printReportMenu();
    },
    enterBaremeMenu: function enterBaremeMenu() {
      this.$refs.childApplication.enterBaremeMenu();
    },
    gotoKnowledgeManagement: function gotoKnowledgeManagement() {
      this.$router.push({ path: '/managementKnowledge/' + this.$route.params.testId });
    },
    gotoStudentManagement: function gotoStudentManagement() {
      this.$router.push({ path: '/managementStudentsGroups' });
    },
    back: function back() {
      this.$refs.childApplication.back();
    },
    addStudent: function addStudent() {
      this.$refs.childApplication.addStudent();
    },
    showAddTest: function showAddTest() {
      this.$refs.childApplication.showAddTest();
    },
    addCenter: function addCenter() {
      this.$refs.childApplication.addCenter();
    },
    addDiscipline: function addDiscipline() {
      this.$refs.childApplication.addDiscipline();
    },
    addTeacher: function addTeacher() {
      this.$refs.childApplication.addTeacher();
    },
    support: function support() {
      this.$router.push({ path: '/support' });
    },
    printStudentGrade: function printStudentGrade() {
      this.$refs.childApplication.printStudentGradeMenu();
    },
    printGroupFormation: function printGroupFormation() {
      this.$refs.childApplication.printGroupFormationMenu();
    },
    printComments: function printComments() {
      this.$refs.childApplication.printCommentsMenu();
    }
  }
});

/***/ }),

/***/ 436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_focus__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_focus__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'changePassword',
  ready: function ready() {
    this.focus = 'newPassword';
    console.log(this.focus);
  },
  data: function data() {
    return {
      code: '',
      counter: 0,
      errorMessage: '',
      focus: '',
      newPassword: '',
      newPasswordConfirm: '',
      oldPassword: '',
      successMessage: '',
      username: ''
    };
  },

  directives: {
    focus: __WEBPACK_IMPORTED_MODULE_2_vue_focus__["focus"]
  },
  mounted: function mounted() {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['api', 'fullname', 'lang'])),
  methods: {
    setErrorMessage: function setErrorMessage() {
      var errorTag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.errorMessage = errorTag;
    },
    setSuccessMessage: function setSuccessMessage() {
      var successMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.successMessage = successMessage;
    },

    changePassword: function changePassword() {
      var _this = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'changePassword',
          newPassword: this.newPassword,
          newPasswordConfirm: this.newPasswordConfirm
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        _this.newPassword = '';
        _this.newPasswordConfirm = '';
        if (response.data.changed) {
          _this.$router.push({ path: '/mainview' });
        } else {
          _this.setErrorMessage(response.data.result.errorText);
        }
      }).catch(function (error) {
        this.newPassword = '';
        this.newPasswordConfirm = '';
        console.log(error);
      });
    },
    changePasswordCancel: function changePasswordCancel() {
      if (this.needPasswordChange) {
        this.$store.commit('LOGOUT');
        this.$router.push({ path: '/' });
      } else {
        this.$router.push({ path: '/mainview' });
      }
    }
  }
});

/***/ }),

/***/ 437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_focus__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_focus__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      code: '',
      counter: 0,
      errorMessage: '',
      focus: '',
      password: '',
      successMessage: '',
      username: ''
    };
  },

  ready: function ready() {
    this.focus = this.username !== '' ? 'username' : 'password';
  },
  directives: {
    focus: __WEBPACK_IMPORTED_MODULE_2_vue_focus__["focus"]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['api', 'fullname', 'lang'])),
  methods: {
    setErrorMessage: function setErrorMessage() {
      var errorTag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.errorMessage = errorTag;
    },

    recoverPassword: function recoverPassword() {
      this.$router.push({ path: '/recoverPassword' });
    },
    setSuccessMessage: function setSuccessMessage() {
      var successMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.successMessage = successMessage;
    },

    authenticate: function authenticate() {
      var _this = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'checkLogin',
          username: this.username,
          password: this.password
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        _this.password = '';
        if (response.data.authenticated) {
          var authObj = {
            changePassword: response.data.changePassword,
            fullname: _this.username,
            token: true,
            adminLevel: response.data.adminLevel,
            licence: response.data.licence
          };
          _this.$store.commit('AUTHENTICATE', authObj);
          _this.$router.push({ path: '/mainview' });
        } else {
          _this.focus = 'username';
          _this.setErrorMessage(_this.$t('LNG_LOGIN_FAILED', _this.lang));
        }
      }).catch(function (error) {
        this.password = '';
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ 438:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bareme',
  components: {},
  data: function data() {
    return {
      testName: '',
      testDiscipline: '',
      testComment: '',
      testDateFormatted: '',
      bareme: [],
      percentSuf: '',
      totalPoints: 0.0
    };
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('fr-ch');
    this.loadTestData();
    this.loadBareme();
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['api', 'fullname', 'lang'])),
  methods: {
    back: function back() {
      this.$router.push({ path: '/testEdit/' + this.$route.params.testId });
    },
    loadTestData: function loadTestData() {
      var _this = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'getTestData',
          id: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        _this.testName = response.data.name;
        _this.testDiscipline = response.data.discipline;
        _this.testComment = response.data.comment;
        _this.testDateFormatted = '';
        if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(response.data.date).isValid()) {
          _this.testDateFormatted = __WEBPACK_IMPORTED_MODULE_2_moment___default()(response.data.date).format('DD.MM.YYYY');
        }
        _this.totalPoints = response.data.totalPts;
      });
    },
    loadBareme: function loadBareme() {
      var _this2 = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'getBaremeData',
          id: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        while (_this2.bareme.length > 0) {
          _this2.bareme.pop();
        }
        response.data.bareme.forEach(function (o) {
          _this2.bareme.push({ id: o.id, label: o.label, min: o.min, src1: o.studentNumber1, src2: o.studentNumber2, src3: o.studentNumber3, src4: o.studentNumber4 });
        });
        _this2.percentSuf = response.data.suff;
      });
    },
    saveGrade: function saveGrade(row, propagate) {
      var _this3 = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'saveGrade',
          id: row.id,
          min: row.min,
          test: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        _this3.loadBareme();
      });
    },
    printBareme: function printBareme(method) {
      var _this4 = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: method,
          testId: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        window.open(_this4.api + '?method=getPdf&name=' + response.data.name + '&clientname=bareme');
      });
    }
  }
});

/***/ }),

/***/ 439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mainview',
  components: {},
  data: function data() {
    return {
      displayStudentImportAlert: false,
      displayStudentImportWarning: false,
      displayStudentImportSuccess: false,
      importedStudents: 0,
      errorMessage: '',
      studentFileHasHeader: 0,
      selectedTest: 0,
      canEditArray: [],
      showMissingDataError: false,
      missingDataErrorMsg: '',
      showErrorSharedStatusChange: false,
      showTop: false,
      fileModalShareTest: false,
      fileModalStudents: false,
      fileModalNewTest: false,
      testName: '',
      testDate: '',
      testDiscipline: '',
      testComment: '',
      dateValue: '',
      format: 'd.M.yyyy',
      clear: true,
      selected: null,
      testData: [],
      comment: '',
      selectDiscipline: {
        options: [],
        value: null
      },
      selectTestGroup: {
        options: [],
        value: []
      },
      testsColumns: ['date', 'discipline', 'name', 'groups', 'comments', 'editTest', 'deleteTest', 'wordButton', 'pdfButton'],
      testsOptions: {
        headings: {
          date: this.$t('LNG_DATE', this.lang),
          discipline: this.$t('LNG_DISCIPLINE', this.lang),
          name: this.$t('LNG_NAME', this.lang),
          groups: this.$t('LNG_GROUPS', this.lang),
          comments: this.$t('LNG_COMMENTS', this.lang),
          editTest: '',
          deleteTest: '',
          wordButton: this.$t('LNG_WORD', this.lang),
          pdfButton: this.$t('LNG_PDF', this.lang)
        },
        filterByColumn: true,
        perPage: 1000,
        perPageValues: [10, 25, 50, 100, 250, 500, 1000],
        texts: this.$parent.tableTexts,
        sortIcon: { base: 'glyphicon', up: 'glyphicon-chevron-up', down: 'glyphicon-chevron-down', is: 'glyphicon-sort' },
        filterable: ['date', 'discipline', 'name', 'groups', 'comments'],
        sortable: ['date', 'discipline', 'name', 'groups', 'comments']
      },
      teacherSharedData: [],
      teacherSharedColumns: ['name', 'firstname', 'shared', 'can_edit'],
      teacherSharedOptions: {
        headings: {
          name: this.$t('LNG_NAME_TEACHER', this.lang),
          firstname: this.$t('LNG_FIRSTNAME', this.lang),

          shared: '',
          can_edit: this.$t('LNG_EDITABLE', this.lang)
        },
        filterByColumn: true,
        perPage: 5,
        perPageValues: [5, 10, 25, 50, 100, 250, 500, 1000],
        texts: this.$parent.tableTexts,
        sortIcon: { base: 'glyphicon', up: 'glyphicon-chevron-up', down: 'glyphicon-chevron-down', is: 'glyphicon-sort' },
        filterable: ['name', 'firstname', 'email'],
        sortable: ['name', 'firstname', 'shared']
      },
      showDeleteModal: false,
      testToDelete: 0,
      showAlertNoLicence: false,
      studentFile: null
    };
  },

  mounted: function mounted() {
    this.loadDisciplineGroups();
    this.getTestList();
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('fr-ch');
    this.$parent.spinner = false;
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['api', 'fullname', 'lang']), {
    adminLevel: function adminLevel() {
      return this.$store.getters.adminLevel;
    }
  }),
  methods: {
    setModalInputFocus: function setModalInputFocus(event) {
      this.$refs.testName.focus();
    },

    editModeClicked: function editModeClicked(id) {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'setTestSharingEditMode',
          can_edit: this.canEditArray[id],
          test: this.selectedTest,
          teacher: id
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {});
    },
    changeSharedStatus: function changeSharedStatus(itemId) {
      var _this = this;

      this.showErrorSharedStatusChange = false;
      var newStatus;
      var testId;
      this.teacherSharedData.forEach(function (sharing) {
        if (sharing.id === itemId) {
          testId = sharing.test;
          if (sharing.shared === '1') {
            newStatus = '0';
          } else {
            newStatus = '1';
          }
        }
      });

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'setTestSharingStatus',
          status: newStatus,
          test: testId,
          teacher: itemId,
          can_edit: this.canEditArray[itemId]
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        if (response.data.status === 'OK') {
          _this.teacherSharedData.forEach(function (sharing) {
            if (sharing.id === itemId) {
              sharing.shared = newStatus;
            }
          });
        } else {
          _this.showErrorSharedStatusChange = true;
        }
      });
    },
    loadShareTeacherData: function loadShareTeacherData(testId) {
      var _this2 = this;

      this.selectedTest = testId;
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'loadTeacherShared',
          test: testId
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        _this2.teacherSharedData = response.data.teachers;
        _this2.teacherSharedData.forEach(function (element) {
          if (element.can_edit === '1') {
            this.canEditArray[element.id] = 1;
          }
        }, _this2);
      });
    },
    openShareBox: function openShareBox(testId) {
      if (this.$store.getters.licence === '1') {
        this.loadShareTeacherData(testId);
        this.showErrorSharedStatusChange = false;
        this.fileModalShareTest = !this.fileModalShareTest;
      } else {
        this.showAlertNoLicence = true;
      }
    },
    exitModalShareTest: function exitModalShareTest() {
      this.selectedTest = 0;
      this.fileModalShareTest = !this.fileModalShareTest;
    },
    getTestList: function getTestList() {
      var _this3 = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'getTestList'
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        _this3.testData = response.data.tests;
        _this3.testData.forEach(function (element) {
          if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(element.date).isValid()) {
            element.date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(element.date).format('DD.MM.YYYY');
          }
        });
      });
    },
    createNewTest: function createNewTest(data) {
      var _this4 = this;

      if (this.testName.length === 0) {
        this.showMissingDataError = true;
        this.missingDataErrorMsg = this.$t('LNG_MISSING_TEST_NAME', this.lang);
        return;
      }
      if (this.testDate.length === 0) {
        this.showMissingDataError = true;
        this.missingDataErrorMsg = this.$t('LNG_TEST_MISSING_DATE', this.lang);
        return;
      }
      if (this.selectDiscipline.value === null) {
        this.showMissingDataError = true;
        this.missingDataErrorMsg = this.$t('LNG_TEST_MISSING_DISCIPLINE', this.lang);
        return;
      }
      if (this.selectTestGroup.value.length === 0) {
        this.showMissingDataError = true;
        this.missingDataErrorMsg = this.$t('LNG_TEST_MISSING_GROUPS', this.lang);
        return;
      }
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'createTest',
          name: this.testName,
          date: this.testDate,
          discipline: this.selectDiscipline.value,
          groups: this.selectTestGroup.value,
          comment: this.comment
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        _this4.fileModalNewTest = !_this4.fileModalNewTest;
        _this4.testName = '';
        _this4.testDate = '';
        _this4.selectDiscipline.value = null;
        _this4.selectTestGroup.value = [];
        _this4.comment = '';
        _this4.getTestList();
      });
    },
    loadDisciplineGroups: function loadDisciplineGroups(data) {
      var _this5 = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'getDisciplineAndGroup'
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        while (_this5.selectDiscipline.options.length > 0) {
          _this5.selectDiscipline.options.pop();
        }
        while (_this5.selectTestGroup.options.length > 0) {
          _this5.selectTestGroup.options.pop();
        }
        response.data.disciplines.forEach(function (e) {
          _this5.selectDiscipline.options.push({ text: e.name + ' ' + e.level, value: e.id });
        });
        response.data.groups.forEach(function (e) {
          _this5.selectTestGroup.options.push({ text: e.name, value: e.id });
        });
      });
    },
    exitFileModalNewTest: function exitFileModalNewTest(data) {
      this.showMissingDataError = false;
      this.fileModalNewTest = !this.fileModalNewTest;
    },
    editATest: function editATest(id) {
      this.$router.push({ path: '/testEdit/' + id });
    },
    deleteATest: function deleteATest(id) {
      this.testToDelete = id;
      this.showDeleteModal = true;
    },
    okDeleteTestAction: function okDeleteTestAction() {
      var _this6 = this;

      this.showDeleteModal = false;
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'deleteATest',
          id: this.testToDelete
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        if (response.data.status === 'OK') {
          var i = 0;
          console.log(_this6.testToDelete);
          for (i = 0; i < _this6.testData.length; i++) {
            if (_this6.testData[i].id === _this6.testToDelete) {
              _this6.testData.splice(i, 1);
            }
          }
          _this6.testToDelete = 0;
        } else {
          _this6.showTop = true;
        }
      });
    },

    openPdf: function openPdf(id) {
      window.open(this.api + '?method=openPdfTestFile&id=' + id);
    },
    openWord: function openWord(id) {
      window.open(this.api + '?method=openWordTestFile&id=' + id);
    },
    cancelAction: function cancelAction() {
      this.showDeleteModal = false;
    },

    openFileModelStudents: function openFileModelStudents() {
      this.fileModalStudents = !this.fileModalStudents;
    },
    exitFileModalStudents: function exitFileModalStudents(data) {
      this.displayStudentImportWarning = false;
      this.displayStudentImportAlert = false;
      this.displayStudentImportSuccess = false;
      this.$refs.fileinput.reset();
      this.fileModalStudents = !this.fileModalStudents;
      this.$emit('closeModal', this.fileModalStudents);
    },
    showAddTest: function showAddTest() {
      this.fileModalNewTest = !this.fileModalNewTest;
    },
    sendFileStudents: function sendFileStudents(event) {
      var _this7 = this;

      event.preventDefault();
      this.displayStudentImportWarning = false;
      this.displayStudentImportAlert = false;
      this.displayStudentImportSuccess = false;
      this.errorMessage = '';
      this.$parent.spinner = true;
      this.formData = new FormData();
      this.formData.append('method', 'uploadFile');
      this.formData.append('import_file', this.studentFile, this.studentFile.name);
      this.axios({
        method: 'post',
        url: this.api + '?method=uploadFileStudents&studentFileHasHeader=' + this.studentFileHasHeader,
        data: this.formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(function (response) {
        if (response.status === 200) {
          if (response.data.status === 'OK') {
            _this7.$parent.spinner = false;

            if (response.data.errors.length > 0 && response.data.numberOfImported === 0) {
              _this7.displayStudentImportWarning = false;
              _this7.displayStudentImportAlert = true;
              _this7.displayStudentImportSuccess = false;
              response.data.errors.forEach(function (e) {
                _this7.errorMessage += e + ' ';
              });
            } else if (response.data.errors.length > 0 || response.data.numberOfImported === 0) {
              _this7.displayStudentImportWarning = true;
              _this7.displayStudentImportAlert = false;
              _this7.displayStudentImportSuccess = false;
              response.data.errors.forEach(function (e) {
                _this7.errorMessage += e + ' ';
              });
            } else {
              _this7.displayStudentImportWarning = false;
              _this7.displayStudentImportAlert = false;
              _this7.displayStudentImportSuccess = true;
            }
            _this7.importedStudents = response.data.numberOfImported;
          } else {
            _this7.$root.$emit('spinner::hide');
            _this7.displayStudentImportWarning = false;
            _this7.displayStudentImportAlert = true;
            _this7.displayStudentImportSuccess = false;
          }
        }
        _this7.$root.$emit('spinner::hide');
        _this7.loadDisciplineGroups();
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ 440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'managementCenter',
  components: {},
  data: function data() {
    return {
      showErrorStatusChange: false,
      showCenterUpdateError: false,
      updateCenterErrorMessage: '',
      centerName: '',
      newCenterModal: false,
      selectedCenter: 0,
      centersData: [],
      centersColumns: ['name', 'grade', 'status', 'editCenter'],
      centersOptions: {
        headings: {
          name: this.$t('LNG_NAME_CENTER', this.lang),
          grade: this.$t('LNG_MAX_GRADE', this.lang),
          status: this.$t('LNG_STATUS', this.lang),
          editCenter: this.$t('LNG_EDIT', this.lang)
        },
        filterByColumn: true,
        perPage: 1000,
        perPageValues: [10, 25, 50, 100, 250, 500, 1000],
        texts: this.$parent.tableTexts,
        sortIcon: { base: 'glyphicon', up: 'glyphicon-chevron-up', down: 'glyphicon-chevron-down', is: 'glyphicon-sort' },
        filterable: ['name'],
        sortable: ['name', 'status']
      },
      btnSaveText: this.$t('LNG_CREATE', this.lang),
      grade: 6
    };
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('fr-ch');
    this.loadCenters();
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['api', 'fullname', 'lang']), {
    adminLevel: function adminLevel() {
      return this.$store.getters.adminLevel;
    }
  }),
  methods: {
    setModalInputFocus: function setModalInputFocus(event) {
      this.$refs.centerName.focus();
    },

    back: function back() {
      this.$router.push({ path: '/' });
    },
    loadCenters: function loadCenters() {
      var _this = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'loadCenters'
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        _this.centersData = response.data.centers;
      });
    },
    changeStatus: function changeStatus(itemId) {
      var _this2 = this;

      this.showErrorStatusChange = false;
      var newStatus;
      this.centersData.forEach(function (center) {
        if (center.id === itemId) {
          if (center.status === '1') {
            newStatus = '0';
          } else {
            newStatus = '1';
          }
        }
      });

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'setCenterStatus',
          status: newStatus,
          centerId: itemId
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        if (response.data.status === 'OK') {
          _this2.centersData.forEach(function (center) {
            if (center.id === itemId) {
              center.status = newStatus;
            }
          });
        } else {
          _this2.showErrorStatusChange = true;
        }
      });
    },
    addCenter: function addCenter() {
      this.showCenterUpdateError = false;
      this.selectedCenter = 0;
      this.grade = 6;
      this.btnSaveText = this.$t('LNG_CREATE', this.lang);
      this.newCenterModal = true;
    },
    exitNewCenterModal: function exitNewCenterModal() {
      this.newCenterModal = false;
      this.showCenterUpdateError = false;
      this.centerName = '';
      this.selectedCenter = 0;
    },
    createUpdateNewCenter: function createUpdateNewCenter(data) {
      var _this3 = this;

      this.showCenterUpdateError = false;
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'createUpdateCenter',
          name: this.centerName,
          grade: this.grade,
          id: this.selectedCenter
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        if (response.data.status === 'OK') {
          _this3.newCenterModal = false;
          _this3.centerName = '';
          _this3.selectedCenter = 0;
          _this3.loadCenters();
        } else {
          _this3.updateCenterErrorMessage = _this3.$t(response.data.error, _this3.lang);
          _this3.showCenterUpdateError = true;
        }
      });
    },
    centerRowClick: function centerRowClick(data) {
      this.selectedCenter = data.row.id;
      this.centerName = data.row.name;
      this.grade = data.row.grade;
      this.showCenterUpdateError = false;
      this.btnSaveText = this.$t('LNG_SAVE', this.lang);
      this.newCenterModal = true;
    }
  }
});

/***/ }),

/***/ 441:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'managementDiscipline',
  components: {},
  data: function data() {
    return {
      selectCenterGroup: {
        options: [],
        value: null
      },
      selectYearGroup: {
        options: [{ value: null, text: this.$t('LNG_SELECT_YEAR', this.lang) }, { value: 2017, text: '2017' }, { value: 2018, text: '2018' }, { value: 2019, text: '2019' }],
        value: null
      },
      selectLevelGroup: {
        options: [{ value: null, text: this.$t('LNG_SELECT_LEVEL', this.lang) }, { value: 1, text: '1' }, { value: 2, text: '2' }],
        value: null
      },
      name: '',
      center: '',
      level: '',
      year: '',
      updateDisciplineErrorMessage: '',
      showDisciplineUpdateError: false,
      disciplineEditionModal: false,
      selectedDiscipline: 0,
      disciplinesData: [],
      newDisciplineFormIsValid: true,
      disciplinesColumns: ['name', 'center', 'level', 'year', 'disabled', 'editDiscipline'],
      disciplinesOptions: {
        headings: {
          name: this.$t('LNG_NAME_TEACHER', this.lang),
          center: this.$t('LNG_CENTER_NAME', this.lang),
          level: this.$t('LNG_LEVEL', this.lang),
          year: this.$t('LNG_YEAR', this.lang),
          disabled: this.$t('LNG_STATUS', this.lang),
          editDiscipline: this.$t('LNG_EDIT', this.lang)
        },
        filterByColumn: true,
        perPage: 1000,
        perPageValues: [10, 25, 50, 100, 250, 500, 1000],
        texts: this.$parent.tableTexts,
        sortIcon: { base: 'glyphicon', up: 'glyphicon-chevron-up', down: 'glyphicon-chevron-down', is: 'glyphicon-sort' },
        filterable: ['name', 'center', 'level', 'year'],
        sortable: ['name', 'center', 'level', 'year']
      },
      disciplineTitle: this.$t('LNG_NEW_DISCIPLINE', this.lang)
    };
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('fr-ch');
    this.loadDisciplines();
    this.loadCenters();
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['api', 'fullname', 'lang']), {
    adminLevel: function adminLevel() {
      return this.$store.getters.adminLevel;
    }
  }),
  methods: {
    setModalInputFocus: function setModalInputFocus(event) {
      this.$refs.name.focus();
    },

    back: function back() {
      this.$router.push({ path: '/' });
    },
    loadCenters: function loadCenters() {
      var _this = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'loadActiveCenters'
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        while (_this.selectCenterGroup.options.length > 0) {
          _this.selectCenterGroup.options.pop();
        }
        _this.selectCenterGroup.options.push({ value: null, text: _this.$t('LNG_SELECT_CENTER_DISCIPLINE_GROUP_DEFAULT', _this.lang) });
        response.data.centers.forEach(function (e) {
          _this.selectCenterGroup.options.push({ value: e.id, text: e.name });
        });
      });
    },
    loadDisciplines: function loadDisciplines() {
      var _this2 = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'getAllDisciplines'
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        _this2.disciplinesData = response.data;
      });
    },
    addDiscipline: function addDiscipline(itemId) {
      this.disciplineTitle = this.$t('LNG_NEW_DISCIPLINE', this.lang);
      this.showDisciplineUpdateError = false;
      this.selectedDiscipline = 0;
      this.disciplineEditionModal = true;
    },
    exitNewDisciplineModal: function exitNewDisciplineModal() {
      this.disciplineEditionModal = false;
      this.showDisciplineUpdateError = false;
      this.name = '';
      this.selectLevelGroup.value = null;
      this.selectYearGroup.value = null;
      this.selectCenterGroup.value = null;
      this.selectedDiscipline = 0;
    },
    changeStatus: function changeStatus(itemId) {
      var _this3 = this;

      this.showErrorStatusChange = false;
      var newStatus;
      this.disciplinesData.forEach(function (discipline) {
        if (discipline.id === itemId) {
          if (discipline.disabled === '1') {
            newStatus = '0';
          } else {
            newStatus = '1';
          }
        }
      });

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'setDisciplineStatus',
          status: newStatus,
          id: itemId
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        if (response.data.status === 'OK') {
          _this3.disciplinesData.forEach(function (discipline) {
            if (discipline.id === itemId) {
              discipline.disabled = newStatus;
            }
          });
        } else {
          _this3.showErrorStatusChange = true;
        }
      });
    },
    createUpdateNewDiscipline: function createUpdateNewDiscipline() {
      var _this4 = this;

      this.showDisciplineUpdateError = false;
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'createUpdateDiscipline',
          name: this.name,
          level: this.selectLevelGroup.value,
          year: this.selectYearGroup.value,
          center: this.selectCenterGroup.value,
          id: this.selectedDiscipline
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        if (response.data.status === 'OK') {
          _this4.disciplineEditionModal = false;
          _this4.name = '';
          _this4.firstname = '';
          _this4.email = '';
          _this4.selectedDiscipline = 0;
          _this4.loadDisciplines();
        } else {
          _this4.updateDisciplineErrorMessage = _this4.$t(response.data.error, _this4.lang);
          _this4.showDisciplineUpdateError = true;
        }
      });
    },
    disciplineRowClick: function disciplineRowClick(data) {
      this.disciplineTitle = this.$t('LNG_EDIT_DISCIPLINE', this.lang);
      this.selectedDiscipline = data.row.id;
      this.name = data.row.name;
      this.selectLevelGroup.value = data.row.level;
      this.selectYearGroup.value = data.row.year;
      this.selectCenterGroup.value = data.row.centerId;
      this.showDisciplineUpdateError = false;
      this.disciplineEditionModal = true;
    }
  }
});

/***/ }),

/***/ 442:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'managementKnowledge',
  components: {},
  data: function data() {
    return {
      testName: '',
      testDiscipline: '',
      testDate: '',
      testComment: '',
      exercices: [],
      checkboxValue: [],
      imageSrc: ''
    };
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('fr-ch');
    this.loadTestData();
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['api', 'fullname', 'lang']), {
    adminLevel: function adminLevel() {
      return this.$store.getters.adminLevel;
    }
  }),
  methods: {
    back: function back() {
      this.$router.push({ path: '/test/' + this.$route.params.testId });
    },
    chkClicked: function chkClicked(exoId, type) {
      var _this = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'saveKnowledge',
          exoId: exoId,
          type: type
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        _this.imageSrc = response.data.imagePath;
      });
    },

    loadTestData: function loadTestData() {
      var _this2 = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'getTestData',
          id: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        _this2.testName = response.data.name;
        _this2.testDiscipline = response.data.discipline;
        _this2.testComment = response.data.comment;
        _this2.testDate = '';
        if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(response.data.date).isValid()) {
          _this2.testDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(response.data.date).format('DD.MM.YYYY');
        }
        var i;
        for (i = 0; i < response.data.exercices.length; i++) {
          if (_this2.exercices.length < response.data.exercices[i].exo) {
            _this2.exercices.push({ id: response.data.exercices[i].exo, objectifs: [] });
          }
          _this2.exercices[response.data.exercices[i].exo - 1].objectifs.push({ objectif: response.data.exercices[i].obj, exoId: response.data.exercices[i].exoId, part: response.data.exercices[i].part });
          _this2.checkboxValue[response.data.exercices[i].exoId] = response.data.exercices[i].category;
        }
      });
    }
  }
});

/***/ }),

/***/ 443:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'managementStudentsGroups',
  components: {},
  data: function data() {
    return {
      editStudent: false,
      showMissingData: false,
      showErrorMessage: false,
      errorMessage: '',
      studentName: '',
      studentFirstname: '',
      selectGroup: {
        options: [],
        value: []
      },
      selectEntity: {
        options: [],
        value: null
      },
      selectedStudent: '',
      studentsData: [],
      studentsColumns: ['name', 'firstname', 'entity', 'groups', 'editStudent'],
      studentsOptions: {
        headings: {
          name: this.$t('LNG_NAME_TEACHER', this.lang),
          firstname: this.$t('LNG_FIRSTNAME', this.lang),
          entity: this.$t('LNG_ENTITY', this.lang),
          groups: this.$t('LNG_GROUPS', this.lang),
          editStudent: this.$t('LNG_EDIT', this.lang)
        },
        filterByColumn: true,
        perPage: 1000,
        perPageValues: [10, 25, 50, 100, 250, 500, 1000],
        texts: this.$parent.tableTexts,
        sortIcon: { base: 'glyphicon', up: 'glyphicon-chevron-up', down: 'glyphicon-chevron-down', is: 'glyphicon-sort' },
        filterable: ['name', 'firstname', 'groups', 'entity'],
        sortable: ['name', 'firstname', 'groups', 'disabled', 'entity']
      },
      editBoxTitle: this.$t('LNG_EDIT_STUDENT', this.lang),
      btnSaveStudent: this.$t('LNG_SAVE', this.lang),
      selectSexe: {
        options: [{ value: null, text: this.$t('LNG_SELECT_SEXE_DEFAULT', this.lang) }, { text: this.$t('LNG_MALE', this.lang), value: '0' }, { text: this.$t('LNG_FEMALE', this.lang), value: '1' }],
        value: null
      },
      showSuccessMessage: false,
      successMessage: '',
      selectedStudentOriginalGroups: [],
      dismissSecs: 5,
      dismissCountDown: 0
    };
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('fr-ch');
    this.loadStudents();
    this.loadMyGroups();
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['api', 'fullname', 'lang'])),
  methods: {
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    addStudent: function addStudent() {
      this.editBoxTitle = this.$t('LNG_ADD_NEW_STUDENT', this.lang);
      this.btnSaveStudent = this.$t('LNG_ADD', this.lang);
      this.editStudent = !this.editStudent;
      this.showErrorMessage = false;
      this.showMissingData = false;
    },
    exitEditStudent: function exitEditStudent() {
      this.resetForm();
      this.editStudent = false;
    },
    resetForm: function resetForm() {
      this.studentName = '';
      this.studentFirstname = '';
      this.selectGroup.value = [];
      this.selectSexe.value = null;
      this.selectEntity.value = null;
      this.selectedStudent = '';
      this.selectedStudentOriginalGroups = [];
      this.showErrorMessage = false;
      this.showMissingData = false;
    },
    saveEditStudent: function saveEditStudent(event) {
      var _this = this;

      this.showErrorMessage = false;
      this.showSuccessMessage = false;
      if (this.selectedStudent === '') {
        this.successMessage = this.$t('LNG_NEW_STUDENT_ADDED', this.lang);
        this.errorMessage = this.$t('LNG_NEW_STUDENT_NOT_ADDED', this.lang);
      } else {
        this.successMessage = this.$t('LNG_STUDENT_UPDATED', this.lang);
        this.errorMessage = this.$t('LNG_STUDENT_NOT_UPDATED', this.lang);
      }

      if (this.studentName === '' || this.studentFirstname === '' || this.selectSexe.value === null || this.selectEntity.value === null || this.selectGroup.value.length === 0) {
        this.showMissingData = true;
        return;
      }
      this.showMissingData = false;
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'addStudent',
          name: this.studentName,
          firstname: this.studentFirstname,
          groups: this.selectGroup.value,
          entity: this.selectEntity.value,
          id: this.selectedStudent,
          sexe: this.selectSexe.value,
          originalGroups: this.selectedStudentOriginalGroups
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        if (response.data.status === 'OK') {
          _this.showSuccessMessage = true;
          _this.resetForm();
          _this.editStudent = false;
          _this.dismissCountDown = _this.dismissSecs;
          _this.loadStudents();
        } else {
          _this.showErrorMessage = true;
        }
      });
    },
    setModalInputFocus: function setModalInputFocus(event) {
      this.$refs.studentFirstname.focus();
    },
    loadStudents: function loadStudents() {
      var _this2 = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'loadMyStudents'
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        _this2.studentsData = response.data.students;
      });
    },
    loadMyGroups: function loadMyGroups() {
      var _this3 = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'loadMyGroups'
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        response.data.groups.forEach(function (e) {
          _this3.selectGroup.options.push({ text: e.name, value: e.id });
        });
        _this3.selectEntity.options.push({ text: _this3.$t('LNG_SELECT_ENTITY_DEFAULT', _this3.lang), value: null });
        response.data.entities.forEach(function (e) {
          _this3.selectEntity.options.push({ text: e.name, value: e.id });
        });
      });
    },

    back: function back() {
      this.$router.push({ path: '/' });
    },
    studentRowClick: function studentRowClick(row) {
      this.editBoxTitle = this.$t('LNG_EDIT_STUDENT', this.lang);
      this.btnSaveStudent = this.$t('LNG_SAVE', this.lang);
      this.selectedStudent = row.row.id;
      this.studentName = row.row.name;
      this.studentFirstname = row.row.firstname;
      this.selectGroup.value = row.row.groupsId;
      this.selectEntity.value = row.row.entityId;
      this.selectSexe.value = row.row.sexe;
      this.editStudent = true;
      this.selectedStudentOriginalGroups = row.row.originalGroupsId;
    }
  }
});

/***/ }),

/***/ 444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'managementTeacher',
  components: {},
  data: function data() {
    return {
      selectCenterGroup: {
        options: [],
        value: null
      },
      displayTeacherImportAlert: false,
      fileModalTeachers: false,
      showErrorStatusChange: false,
      newTeacherFormIsValid: false,
      showTeacherUpdateError: false,
      displayTeacherImportWarning: false,
      displayTeacherImportSuccess: false,
      teacherFileHasHeader: false,
      teachersFile: 'import_file',
      updateTeacherErrorMessage: '',
      importedTeachers: 0,
      errorMessage: '',
      name: '',
      firstname: '',
      email: '',
      teacherEditionModal: false,
      selectedTeacher: 0,
      teachersData: [],
      teachersColumns: ['name', 'firstname', 'email', 'lastLogin', 'center', 'disabled', 'editTeacher'],
      teachersOptions: {
        headings: {
          name: this.$t('LNG_NAME_TEACHER', this.lang),
          firstname: this.$t('LNG_FIRSTNAME', this.lang),
          email: this.$t('LNG_EMAIL', this.lang),
          lastLogin: this.$t('LNG_LAST_LOGIN', this.lang),
          center: this.$t('LNG_CENTER_NAME', this.lang),
          disabled: this.$t('LNG_STATUS', this.lang),
          editTeacher: this.$t('LNG_EDIT', this.lang)
        },
        filterByColumn: true,
        perPage: 1000,
        perPageValues: [10, 25, 50, 100, 250, 500, 1000],
        texts: this.$parent.tableTexts,
        sortIcon: { base: 'glyphicon', up: 'glyphicon-chevron-up', down: 'glyphicon-chevron-down', is: 'glyphicon-sort' },
        filterable: ['name', 'firstname', 'email', 'center'],
        sortable: ['name', 'firstname', 'email', 'lastLogin', 'center', 'disabled']
      },
      addTeacherTitle: this.$t('LNG_NEW_TEACHER', this.lang)
    };
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('fr-ch');
    this.loadTeachers();
    this.loadCenters();
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['api', 'fullname', 'lang']), {
    adminLevel: function adminLevel() {
      return this.$store.getters.adminLevel;
    }
  }),
  methods: {
    setModalInputFocus: function setModalInputFocus(event) {
      this.$refs.name.focus();
    },

    back: function back() {
      this.$router.push({ path: '/' });
    },
    loadCenters: function loadCenters() {
      var _this = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'loadActiveCenters'
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        while (_this.selectCenterGroup.options.length > 0) {
          _this.selectCenterGroup.options.pop();
        }
        _this.selectCenterGroup.options.push({ value: null, text: _this.$t('LNG_SELECT_CENTER_TEACHER_GROUP_DEFAULT', _this.lang) });
        response.data.centers.forEach(function (e) {
          _this.selectCenterGroup.options.push({ text: e.name, value: e.id });
        });
      });
    },
    loadTeachers: function loadTeachers() {
      var _this2 = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'loadTeachers'
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        _this2.teachersData = response.data.teachers;
        _this2.teachersData.forEach(function (element) {
          if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(element.lastLogin).isValid()) {
            element.lastLogin = __WEBPACK_IMPORTED_MODULE_2_moment___default()(element.lastLogin).format('DD.MM.YYYY HH:mm:s');
          }
        });
      });
    },
    changeStatus: function changeStatus(itemId) {
      var _this3 = this;

      this.showErrorStatusChange = false;
      var newStatus;
      this.teachersData.forEach(function (teacher) {
        if (teacher.id === itemId) {
          if (teacher.disabled === '1') {
            newStatus = '0';
          } else {
            newStatus = '1';
          }
        }
      });

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'setTeacherStatus',
          status: newStatus,
          id: itemId
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        if (response.data.status === 'OK') {
          _this3.teachersData.forEach(function (teacher) {
            if (teacher.id === itemId) {
              teacher.disabled = newStatus;
            }
          });
        } else {
          _this3.showErrorStatusChange = true;
        }
      });
    },
    addTeacher: function addTeacher(itemId) {
      this.addTeacherTitle = this.$t('LNG_NEW_TEACHER', this.lang);
      this.showTeacherUpdateError = false;
      this.selectedTeacher = 0;
      this.teacherEditionModal = true;
    },
    exitNewTeacherModal: function exitNewTeacherModal() {
      this.teacherEditionModal = false;
      this.showTeacherUpdateError = false;
      this.name = '';
      this.firstname = '';
      this.email = '';
      this.selectCenterGroup.value = null;
      this.selectedTeacher = 0;
    },
    createUpdateNewTeacher: function createUpdateNewTeacher() {
      var _this4 = this;

      this.showTeacherUpdateError = false;
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'createUpdateTeacher',
          name: this.name,
          firstname: this.firstname,
          email: this.email,
          center: this.selectCenterGroup.value,
          id: this.selectedTeacher
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        if (response.data.status === 'OK') {
          _this4.teacherEditionModal = false;
          _this4.name = '';
          _this4.firstname = '';
          _this4.email = '';
          _this4.selectCenterGroup.value = null;
          _this4.selectedTeacher = 0;
          _this4.loadTeachers();
        } else {
          _this4.updateTeacherErrorMessage = _this4.$t(response.data.error, _this4.lang);
          _this4.showTeacherUpdateError = true;
        }
      });
    },
    teacherRowClick: function teacherRowClick(data) {
      this.addTeacherTitle = this.$t('LNG_EDIT_TEACHER', this.lang);
      this.selectedTeacher = data.row.id;
      this.name = data.row.name;
      this.firstname = data.row.firstname;
      this.email = data.row.email;
      this.selectCenterGroup.value = data.row.centerId;
      this.showTeacherUpdateError = false;
      this.teacherEditionModal = true;
    },
    exitFileModalTeacher: function exitFileModalTeacher() {
      this.displayTeacherImportWarning = false;
      this.displayTeacherImportAlert = false;
      this.displayTeacherImportSuccess = false;
      this.fileModalTeachers = !this.fileModalTeachers;
    },
    importTeacher: function importTeacher() {
      this.displayTeacherImportWarning = false;
      this.displayTeacherImportAlert = false;
      this.displayTeacherImportSuccess = false;
      var input = this.$refs.fileuploadteacher;
      input.type = 'text';
      input.type = 'file';
      this.fileModalTeachers = !this.fileModalTeachers;
    },
    sendFileTeachers: function sendFileTeachers(event) {
      var _this5 = this;

      event.preventDefault();
      this.displayTeacherImportWarning = false;
      this.displayTeacherImportAlert = false;
      this.displayTeacherImportSuccess = false;
      this.errorMessage = '';
      this.$root.$emit('spinner::show');
      this.formData = new FormData();
      this.formData.append('method', 'uploadFile');
      this.formData.append('import_file', this.teachersFile, this.teachersFile.name);
      this.axios({
        method: 'post',
        url: this.api + '?method=uploadFileTeachers&teacherFileHasHeader=' + this.teacherFileHasHeader,
        data: this.formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(function (response) {
        _this5.$root.$emit('spinner::hide');
        if (response.status === 200) {
          if (response.data.status === 'OK') {
            _this5.importedTeachers = response.data.numberOfImported;
            if (response.data.errors.length > 0 || response.data.errorsCenter.length > 0 || response.data.missingEmail.length > 0 || response.data.centerEmpty > 0) {
              _this5.displayTeacherImportWarning = false;
              _this5.displayTeacherImportAlert = true;
              _this5.displayTeacherImportSuccess = false;

              if (response.data.errors.length > 0) {
                _this5.errorMessage += _this5.$t('LNG_ERRORS_DOTS', _this5.lang);
                response.data.errors.forEach(function (e) {
                  _this5.errorMessage += e + ' ';
                });
                _this5.errorMessage += '\r\n';
              }
              if (response.data.errorsCenter.length > 0) {
                _this5.errorMessage += _this5.$t('LNG_ERRORS_CENTER_DOTS', _this5.lang);
                response.data.errorsCenter.forEach(function (e) {
                  _this5.errorMessage += e + ' ';
                });
                _this5.errorMessage += '\r\n';
              }
              if (response.data.missingEmail.length > 0) {
                _this5.errorMessage += _this5.$t('LNG_ERRORS_MISSING_EMAILS_DOTS', _this5.lang);
                response.data.missingEmail.forEach(function (e) {
                  _this5.errorMessage += e + ' ';
                });
                _this5.errorMessage += '\r\n';
              }
              if (response.data.existingEmails.length > 0) {
                _this5.errorMessage += _this5.$t('LNG_ERRORS_EXISTING_EMAILS_DOTS', _this5.lang);
                response.data.existingEmails.forEach(function (e) {
                  _this5.errorMessage += e + ' ';
                });
                _this5.errorMessage += '\r\n';
              }
              if (response.data.centerEmpty > 0) {
                if (response.data.centerEmpty > 1) {
                  _this5.errorMessage += _this5.$t('LNG_ERRORS_CENTERS_EMPTY', _this5.lang, { centerEmpty: response.data.centerEmpty });
                } else {
                  _this5.errorMessage += _this5.$t('LNG_ERRORS_CENTER_EMPTY', _this5.lang);
                }
                _this5.errorMessage += '\r\n';
              }
            } else if (response.data.existingEmails.length > 0) {
              _this5.displayTeacherImportWarning = true;
              _this5.displayTeacherImportAlert = false;
              _this5.displayTeacherImportSuccess = false;

              _this5.errorMessage += _this5.$t('LNG_ERRORS_EXISTING_EMAILS_DOTS', _this5.lang);
              response.data.existingEmails.forEach(function (e) {
                _this5.errorMessage += e + ' ';
              });
              _this5.errorMessage += '\r\n';
            } else {
              _this5.displayTeacherImportWarning = false;
              _this5.displayTeacherImportAlert = false;
              _this5.displayTeacherImportSuccess = true;
              _this5.errorMessage = response.data.numberOfImported;
            }
            _this5.errorMessage += _this5.$t('LNG_TEACHER_IMPORT_SUCCESSMESSAGE_DETAILS', _this5.lang, { importedTeachers: response.data.numberOfImported });
          } else {
            _this5.displayTeacherImportWarning = false;
            _this5.displayTeacherImportAlert = true;
            _this5.displayTeacherImportSuccess = false;
            _this5.errorMessage = _this5.$t('LNG_FILE_NOT_UPLOADED', _this5.lang);
          }
          _this5.loadTeachers();
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ 445:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mainview',
  components: {},
  data: function data() {
    return {};
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('fr-ch');
    this.$parent.spinner = false;
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['api', 'fullname', 'lang']), {
    adminLevel: function adminLevel() {
      return this.$store.getters.adminLevel;
    }
  }),
  methods: {}
});

/***/ }),

/***/ 446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_focus__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_focus__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'recoverPassword',
  components: {},
  data: function data() {
    return {
      username: '',
      errorAlertShown: 0,
      showSuccess: 0,
      dismissSecs: 5,
      focus: ''
    };
  },

  mounted: function mounted() {
    this.focus = 'username';
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['api', 'fullname', 'lang'])),
  directives: {
    focus: __WEBPACK_IMPORTED_MODULE_2_vue_focus__["focus"]
  },
  methods: {
    setErrorMessage: function setErrorMessage() {
      var errorTag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.errorMessage = errorTag;
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.successAlertShown = dismissCountDown;
    },

    recoverPassword: function recoverPassword() {
      var _this = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'resetPassword',
          username: this.username
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        if (response.data.status === 'OK') {
          _this.showSuccess = _this.dismissSecs;
          _this.$router.push({ path: '/' });
        } else {
          _this.successAlertShown = _this.dismissSecs;
        }
      });
    }
  }
});

/***/ }),

/***/ 447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mainview',
  components: {},
  data: function data() {
    return {
      checked: true,
      testName: '',
      testComment: '',
      testDiscipline: '',
      selectStudent: {
        options: [],
        value: null
      },
      exercices: [],
      graphSource: '',
      imageSrcSpider: '',
      imageSrcKnowledge: '',
      selectedExercice: -1,
      selectedPart: -1,
      selectedObjective: -1,
      exerciceIsSelected: [],
      partIsSelected: [],
      objectiveIsSelected: [],
      exerciceIsShown: [],
      loading: false,
      studentPoints: [],
      totalByExoStudent: [],
      totalByPartStudent: [],
      totalPointsStudent: 0
    };
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale('fr-ch');
    this.loadData();
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['api', 'fullname', 'lang']), {
    totalByExo: function totalByExo() {
      var totalExo = [];
      var temp = 0;
      var cpt = 0;
      this.exercices.forEach(function (element) {
        totalExo[cpt] = [];
        totalExo[cpt]['parts'] = [];
        if (element['parts'] !== undefined) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(element['parts']).forEach(function (key2) {
            totalExo[cpt]['parts'][key2] = 0;
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(element['parts'][key2]['exercices']).forEach(function (key3) {
              if (element['parts'][key2]['exercices'][key3]['pts'] !== '' && element['parts'][key2]['exercices'][key3]['pts'] != null) {
                temp = temp + parseFloat(element['parts'][key2]['exercices'][key3]['pts']);
                totalExo[cpt]['parts'][key2] = totalExo[cpt]['parts'][key2] + parseFloat(element['parts'][key2]['exercices'][key3]['pts']);
              }
            }, this);
          }, this);
        }
        totalExo[cpt]['points'] = temp;
        cpt = cpt + 1;
        temp = 0;
      }, this);
      return totalExo;
    }
  }),
  methods: {
    loadData: function loadData() {
      var _this = this;

      this.loading = true;
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'getTestDataResults',
          id: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        _this.testName = response.data.name;
        _this.testDiscipline = response.data.discipline;

        while (_this.selectStudent.options.length > 0) {
          _this.selectStudent.options.pop();
        }
        _this.selectStudent.options.push({ text: _this.$t('LNG_PLEASE_SELECT_A_STUDENT', _this.lang), value: null });
        response.data.students.forEach(function (e) {
          _this.selectStudent.options.push({ text: e.name + ' (' + e.points + ' pts' + ' ' + e.grade + ')', value: e.id });
        });

        _this.exercices = [];
        _this.exercices = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response.data.exercices).map(function (k) {
          return response.data.exercices[k];
        });

        var cpt = 0;
        _this.studentPoints = [];
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.exercices).forEach(function (key) {
          this.exerciceIsShown[cpt] = true;
          this.exerciceIsSelected[cpt] = false;
          this.studentPoints[cpt + 1] = [];
          this.totalByPartStudent[cpt] = [];
          cpt = cpt + 1;
        }, _this);

        _this.exercices.forEach(function (e) {
          var p = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(e.parts).map(function (k) {
            return e.parts[k];
          });
          p.forEach(function (pp) {
            _this.studentPoints[e.exoNumber][_this.partLetterToNumber(pp.partName)] = [];
            pp.exercices.forEach(function (exo) {
              _this.studentPoints[e.exoNumber][_this.partLetterToNumber(pp.partName)][exo.pos] = { id: exo.exoId, pts: '', comments: '' };
            });
          });
        });
        _this.totalPoints = response.data.totalPts;
        _this.loading = false;
      });
    },
    partLetterToNumber: function partLetterToNumber(letter) {
      switch (letter) {
        case 'a':
          return 1;
        case 'b':
          return 2;
        case 'c':
          return 3;
        case 'd':
          return 4;
        case 'e':
          return 5;
        case 'f':
          return 6;
        case 'g':
          return 7;
        case 'h':
          return 8;
        case 'i':
          return 9;
        case 'j':
          return 10;
        case 'k':
          return 11;
        case 'l':
          return 12;
        case 'm':
          return 13;
        case 'n':
          return 14;
        case 'o':
          return 15;
        case 'p':
          return 16;
        case 'q':
          return 17;
      }
      return 0;
    },
    selectExercice: function selectExercice(position, event) {
      if (this.selectedPart !== -1) {
        this.partIsSelected[this.selectedPart] = false;
        this.selectedPart = -1;
      }
      if (this.selectedObjective !== -1) {
        this.objectiveIsSelected[this.selectedObjective] = false;
        this.selectedObjective = -1;
      }
      if (this.selectedExercice === position) {
        this.exerciceIsSelected[this.selectedExercice] = false;
        this.selectedExercice = -1;
      } else {
        this.exerciceIsSelected[this.selectedExercice] = false;
        this.selectedExercice = position;
        this.exerciceIsSelected[this.selectedExercice] = true;
      }
      event.stopPropagation();
      this.$forceUpdate();
    },
    selectPart: function selectPart(indexExo, indexPart) {
      if (this.selectedExercice !== -1) {
        this.exerciceIsSelected[this.selectedExercice] = false;
        this.selectedExercice = -1;
      }
      if (this.selectedObjective !== -1) {
        this.objectiveIsSelected[this.selectedObjective] = false;
        this.selectedObjective = -1;
      }
      if (this.selectedPart === 100 * indexExo + indexPart) {
        this.partIsSelected[100 * indexExo + indexPart] = false;
        this.selectedPart = -1;
      } else {
        this.partIsSelected[this.selectedPart] = false;
        this.selectedPart = 100 * indexExo + indexPart;
        this.partIsSelected[this.selectedPart] = true;
      }
      this.$forceUpdate();
    },

    selectObjective: function selectObjective(exoId) {
      if (this.selectedPart !== -1) {
        this.partIsSelected[this.selectedPart] = false;
        this.selectedPart = -1;
      }
      if (this.selectedExercice !== -1) {
        this.exerciceIsSelected[this.selectedExercice] = false;
        this.selectedExercice = -1;
      }
      if (this.selectedObjective === exoId) {
        this.objectiveIsSelected[exoId] = false;
        this.selectedObjective = -1;
      } else {
        this.objectiveIsSelected[this.selectedObjective] = false;
        this.selectedObjective = exoId;
        this.objectiveIsSelected[exoId] = true;
      }
      this.$forceUpdate();
    },
    toggleExercice: function toggleExercice(event, exerciceNumber) {
      event.stopPropagation();
      this.exerciceIsShown[exerciceNumber] = !this.exerciceIsShown[exerciceNumber];
      this.$forceUpdate();
    },

    studentSelected: function studentSelected(newSelection) {
      var _this2 = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'getTestPtStudent',
          testId: this.$route.params.testId,
          studentId: newSelection
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        _this2.loading = true;
        var cpt = 0;
        var cptPart = 1;
        _this2.studentPoints.forEach(function (parts) {
          _this2.totalByExoStudent[cpt] = 0;
          _this2.totalByPartStudent[cpt] = [];
          cptPart = 1;
          parts.forEach(function (exos) {
            _this2.totalByPartStudent[cpt][cptPart] = 0;
            exos.forEach(function (e) {
              e.pts = '';
              e.comments = '';
            });
            cptPart = cptPart + 1;
          });
          cpt = cpt + 1;
        });
        if (response.data.points.length > 0) {
          response.data.points.forEach(function (re) {
            _this2.studentPoints[re.exoNum][_this2.partLetterToNumber(re.part)][re.pos].pts = re.points;
            _this2.studentPoints[re.exoNum][_this2.partLetterToNumber(re.part)][re.pos].comments = re.comments;
            _this2.totalByExoStudent[re.exoNum - 1] = Number(_this2.totalByExoStudent[re.exoNum - 1]) + Number(re.points);
            _this2.totalByPartStudent[re.exoNum - 1][_this2.partLetterToNumber(re.part)] = _this2.totalByPartStudent[re.exoNum - 1][_this2.partLetterToNumber(re.part)] + Number(re.points);
          });
        }
        _this2.loading = false;

        _this2.imageSrcSpider = response.data.imagePathSpider;

        _this2.imageSrcKnowledge = response.data.imageSrcKnowledge;

        _this2.totalPointsStudent = _this2.calculateTotalStudent();
      });
    },
    back: function back() {
      this.$router.push({ path: '/testEdit/' + this.$route.params.testId });
    },
    savePoints: function savePoints(exoId, exoPts) {
      var _this3 = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'savePointsToStudent',
          testId: this.$route.params.testId,
          studentId: this.selectStudent.value,
          exercice: exoId,
          points: exoPts
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        _this3.imageSrcSpider = response.data.imagePathSpider;
        _this3.imageSrcKnowledge = response.data.imageSrcKnowledge;

        _this3.totalByExoStudent[response.data.number - 1] = response.data.exoPoints;

        _this3.totalByPartStudent[response.data.number - 1][_this3.partLetterToNumber(response.data.part)] = response.data.partPoint;

        _this3.totalPointsStudent = _this3.calculateTotalStudent();
      });
    },
    saveComments: function saveComments(exoId, exoComments) {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'saveCommentsToStudent',
          testId: this.$route.params.testId,
          studentId: this.selectStudent.value,
          exercice: exoId,
          comments: exoComments
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {});
    },
    getStudentGraph: function getStudentGraph() {
      var _this4 = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'getStudentRadarGraph',
          testId: this.$route.params.testId,
          studentId: this.selectStudent.value
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        _this4.graphSource = response.data.image;
      });
    },
    calculateTotalStudent: function calculateTotalStudent() {
      var total = 0;
      this.studentPoints.forEach(function (parts) {
        parts.forEach(function (exos) {
          exos.forEach(function (e) {
            if (e !== null & e.pts !== null) {
              total = total + Number(e.pts);
            }
          });
        });
      });
      return total;
    }
  }
});

/***/ }),

/***/ 448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_focus__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_focus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_recaptcha__ = __webpack_require__(892);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'support',
  components: {
    VueRecaptcha: __WEBPACK_IMPORTED_MODULE_4_vue_recaptcha__["a" /* default */]
  },
  ready: function ready() {
    this.focus = 'myMessage';
  },
  data: function data() {
    return {
      myMessage: '',
      notSent: true,
      notSentError: false,
      focus: '',
      displaySendMessage: false
    };
  },

  directives: {
    focus: __WEBPACK_IMPORTED_MODULE_3_vue_focus__["focus"]
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('fr-ch');
    this.$refs.myMessage.focus();
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])(['api', 'fullname', 'lang']), {
    adminLevel: function adminLevel() {
      return this.$store.getters.adminLevel;
    }
  }),
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      this.notSentError = false;
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'sendMessage',
          data: this.myMessage
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        if (response.data.status === 'OK') {
          _this.notSent = false;
        } else {
          _this.notSentError = true;
        }
      });
    },
    exit: function exit() {
      this.$router.push({ path: '/' });
    },
    okC: function okC() {
      this.displaySendMessage = true;
    }
  }
});

/***/ }),

/***/ 449:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_select__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_focus__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_focus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_focus__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'testEdit',
  components: {
    vSelect: __WEBPACK_IMPORTED_MODULE_4_vue_select___default.a
  },
  directives: {
    focus: __WEBPACK_IMPORTED_MODULE_5_vue_focus__["focus"]
  },
  data: function data() {
    return {
      displayTestInfos: true,
      exerciceIsShown: [],
      exerciceIsSelected: [],
      partIsSelected: [],
      objectiveIsSelected: [],
      testName: '',
      testComment: '',
      testDiscipline: '',
      testDateBrut: '',
      exercices: [],
      numberOfNewExercice: 1,
      numberOfNewParts: 1,
      numberOfNewObjectives: 1,
      modalAddExerciceShown: false,
      modalAddPartShown: false,
      modalErroMessageShown: false,
      modalAddObjectivesShown: false,
      yesNoModalShown: false,
      fileUploadTestModalShown: false,
      modalObjectiveSelectionShown: false,
      spinnerModalShown: false,
      successAlertShown: 0,
      selectedPosition: 'end',
      selectedPositionPart: 'end',
      selectedObjective: 0,
      errorMessage: '',
      yesNoTitle: '',
      yesNoQuestion: '',
      missingDataErrorShown: false,
      missingDataErrorMsg: '',
      formData: new FormData(),
      wordFile: null,
      pdfFile: null,
      dismissSecs: 5,
      sucessAlertMessage: '',
      progressBarValue: 0,
      progressBarTimeout: null,
      yesNoModalType: '',
      selectedParts: 'end',
      objectifsList: [],
      selectedObjectiveInList: null,
      exerciceIdToLinkObj: null,
      newObjectiveText: '',
      displayUploadAlert: false };
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale('fr-ch');
    this.loadTestData();
    this.loadObjectivesList();
    this.formData.append('method', 'uploadFile');
    this.$parent.isSideBarVisible = true;
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.isSideBarVisible = false;
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])(['api', 'fullname', 'lang']), {
    totalPoints: function totalPoints() {
      var exosPoints = this.totalByExo;
      var total = 0;
      exosPoints.forEach(function (val) {
        if (val['points'] !== undefined) {
          total = total + val['points'];
        }
      });
      return total;
    },
    totalByExo: function totalByExo() {
      var totalExo = [];
      var temp = 0;
      var cpt = 0;
      this.exercices.forEach(function (element) {
        totalExo[cpt] = [];
        totalExo[cpt]['parts'] = [];
        if (element['parts'] !== undefined) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(element['parts']).forEach(function (key2) {
            totalExo[cpt]['parts'][key2] = 0;
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(element['parts'][key2]['exercices']).forEach(function (key3) {
              if (element['parts'][key2]['exercices'][key3]['pts'] !== '' && element['parts'][key2]['exercices'][key3]['pts'] != null) {
                temp = temp + parseFloat(element['parts'][key2]['exercices'][key3]['pts']);
                totalExo[cpt]['parts'][key2] = totalExo[cpt]['parts'][key2] + parseFloat(element['parts'][key2]['exercices'][key3]['pts']);
              }
            }, this);
          }, this);
        }
        totalExo[cpt]['points'] = temp;
        cpt = cpt + 1;
        temp = 0;
      }, this);
      return totalExo;
    },
    testDateFormatted: function testDateFormatted() {
      if (__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.testDateBrut).isValid()) {
        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.testDateBrut).format('DD.MM.YYYY');
      }
      return this.testDateBrut;
    }
  }),
  methods: {
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.successAlertShown = dismissCountDown;
    },

    loadTestData: function loadTestData() {
      var _this = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'getTestData',
          id: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        _this.exercices = [];
        _this.exercices = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response.data.exercices).map(function (k) {
          return response.data.exercices[k];
        });

        var cpt = 0;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.exercices).forEach(function (key) {
          this.exerciceIsShown[cpt] = true;
          this.exerciceIsSelected[cpt] = false;
          cpt = cpt + 1;
        }, _this);

        _this.testName = response.data.name;
        _this.testDiscipline = response.data.discipline;
        _this.testComment = response.data.comment;
        _this.testDateBrut = response.data.date;
        _this.selectedPosition = 'end';
        _this.selectedParts = 'end';
        _this.partIsSelected = [];
      });
    },
    loadObjectivesList: function loadObjectivesList() {
      var _this2 = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'getObjectiveList',
          id: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        _this2.objectifsList = response.data.objectives;
      });
    },
    toggleExercice: function toggleExercice(event, exerciceNumber) {
      event.stopPropagation();
      this.exerciceIsShown[exerciceNumber] = !this.exerciceIsShown[exerciceNumber];
      this.$forceUpdate();
    },
    showAddExerciceModal: function showAddExerciceModal() {
      this.modalAddExerciceShown = !this.modalAddExerciceShown;
    },
    showAddPartModal: function showAddPartModal() {
      if (this.selectedParts === 'end' && this.selectedPosition === 'end') {
        this.errorMessage = this.$t('LNG_YOU_NEED_TO_SELECTED_AN_EXERCICE_OR_A_PART', this.lang);
        this.modalErroMessageShown = true;
        return;
      }
      this.modalAddPartShown = !this.modalAddPartShown;
    },
    addNewExerciceToTest: function addNewExerciceToTest(position) {
      var _this3 = this;

      this.modalAddExerciceShown = !this.modalAddExerciceShown;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'addExerciceToTest',
          id: this.$route.params.testId,
          position: this.selectedPosition,
          number: this.numberOfNewExercice
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        _this3.loadTestData();
      });
    },
    selectExercice: function selectExercice(position, event) {
      event.stopPropagation();
      if (this.selectedPosition !== 'end' && this.selectedPosition !== position) {
        this.exerciceIsSelected[this.selectedPosition] = !this.exerciceIsSelected[this.selectedPosition];
      }

      if (this.selectedObjective !== 0) {
        this.objectiveIsSelected[this.selectedObjective] = false;
        this.selectedObjective = 0;
      }

      if (this.selectedParts !== 'end') {
        this.partIsSelected[this.selectedParts] = false;
        this.selectedParts = 'end';
      }
      if (this.exerciceIsSelected[position]) {
        this.selectedPosition = 'end';
      } else {
        this.selectedPosition = position;
      }
      this.exerciceIsSelected[position] = !this.exerciceIsSelected[position];
      this.$forceUpdate();
    },
    selectPart: function selectPart(indexExo, indexPart) {
      if (this.selectedPosition !== 'end') {
        this.exerciceIsSelected[this.selectedPosition] = !this.exerciceIsSelected[this.selectedPosition];
        this.selectedPosition = 'end';
      }

      if (this.selectedObjective !== 0) {
        this.objectiveIsSelected[this.selectedObjective] = false;
        this.selectedObjective = 0;
      }

      if (this.partIsSelected[100 * indexExo + indexPart]) {
        this.partIsSelected[this.selectedParts] = false;
        this.selectedParts = 'end';
        this.selectedPositionPart = 'end';
      } else {
        if (this.selectedParts !== 'end') {
          this.partIsSelected[this.selectedParts] = false;
        }
        this.selectedParts = 100 * indexExo + indexPart;
        this.partIsSelected[this.selectedParts] = true;
        this.selectedPositionPart = 'selected';
      }

      this.$forceUpdate();
    },
    showRemoveExerciceModal: function showRemoveExerciceModal() {
      if (this.selectedPosition === 'end') {
        this.errorMessage = this.$t('LNG_YOU_MUST_SELECT_AN_EXERCICE', this.lang);
        this.modalErroMessageShown = !this.modalErroMessageShown;
      } else {
        this.yesNoQuestion = this.$t('LNG_DO_YOU_WANT_TO_DELETE_EXERCICE', this.lang, { exoNum: this.selectedPosition + 1 });
        this.yesNoTitle = this.$t('LNG_DO_YOU_WANT_TO_CONTINUE', this.lang);
        this.yesNoModalType = 'removeExercice';
        this.yesNoModalShown = !this.yesNoModalShown;
      }
    },

    saveTestInformation: function saveTestInformation() {
      var _this4 = this;

      if (this.testName.length === 0) {
        this.missingDataErrorShown = true;
        this.missingDataErrorMsg = this.$t('LNG_MISSING_TEST_NAME', this.lang);
        return;
      }
      if (this.testDateBrut.length === 0) {
        this.missingDataErrorShown = true;
        this.missingDataErrorMsg = this.$t('LNG_TEST_MISSING_DATE', this.lang);
        return;
      }
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'updateTestInformation',
          name: this.testName,
          date: this.testDateBrut,
          comment: this.testComment,
          testId: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        if (response.data.status === 'OK') {
          _this4.missingDataErrorShown = false;
          _this4.displayTestInfos = true;
        } else {
          _this4.missingDataErrorShown = true;
        }
      });
    },
    pointsChanged: function pointsChanged(id, pts) {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'savePointsToExo',
          id: id,
          pts: pts
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {});
    },
    uploadFileTest: function uploadFileTest() {
      var _this5 = this;

      this.formData = new FormData();
      this.formData.append('method', 'uploadFile');
      if (this.wordFile !== null) {
        this.formData.append('wordFile', this.wordFile, this.wordFile.name);
      }
      if (this.pdfFile !== null) {
        this.formData.append('pdfFile', this.pdfFile, this.pdfFile.name);
      }
      this.axios({
        method: 'post',
        url: this.api + '?method=uploadTestFile&testId=' + this.$route.params.testId,
        data: this.formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(function (response) {
        if (response.status === 200) {
          if (response.data.status === 'OK') {
            _this5.fileUploadTestModalShown = false;
            _this5.sucessAlertMessage = _this5.$t('LNG_TEST_FILE_WAS_UPLOADED', _this5.lang);
            _this5.successAlertShown = _this5.dismissSecs;
          } else {
            var pdf = false;
            var docx = false;
            response.data.errors.forEach(function (e) {
              if (e === 'docx') {
                docx = true;
              }
              if (e === 'pdf') {
                pdf = true;
              }
            });
            if (pdf & docx) {
              _this5.uploadedFileErroMessage = _this5.$t('LNG_UPLOADED_FILE_NOT_PDF_NOT_WORD', _this5.lang);
            } else if (pdf) {
              _this5.uploadedFileErroMessage = _this5.$t('LNG_UPLOADED_FILE_NOT_PDF', _this5.lang);
            } else if (docx) {
              _this5.uploadedFileErroMessage = _this5.$t('LNG_UPLOADED_FILE_NOT_WORD', _this5.lang);
            }
            _this5.displayUploadAlert = true;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    progressBarUpload: function progressBarUpload() {
      if (this.progressBarValue === 100) {
        this.progressBarValue = 0;
      } else {
        this.progressBarValue = this.progressBarValue + 10;
      }
    },
    back: function back() {
      this.$router.push({ path: '/' });
    },
    yesNoModal_YES: function yesNoModal_YES() {
      if (this.yesNoModalType === 'removeExercice') {
        this.removeSelectedExercice();
      }
      if (this.yesNoModalType === 'removePart') {
        this.removeSelectedPart();
        this.yesNoModalShown = !this.yesNoModalShown;
      }
      if (this.yesNoModalType === 'removeObjective') {
        this.removeSelectedObjective();
        this.yesNoModalShown = !this.yesNoModalShown;
      }
    },
    removeSelectedExercice: function removeSelectedExercice() {
      var _this6 = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'removeExercice',
          number: this.selectedPosition + 1,
          id: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        if (response.status === 200) {
          if (response.data.status === 'OK') {
            _this6.yesNoModalShown = !_this6.yesNoModalShown;
            _this6.sucessAlertMessage = _this6.$t('LNG_EXERCICE_DELETED', _this6.lang);

            _this6.successAlertShown = _this6.dismissSecs;
            _this6.loadTestData();
          }
        }
      });
    },
    toggleAllExercices: function toggleAllExercices() {
      var cpt = 0;
      this.exerciceIsShown.forEach(function (e) {
        this.exerciceIsShown[cpt] = false;
        cpt = cpt + 1;
      }, this);
      this.$forceUpdate();
    },
    addNewPartToTest: function addNewPartToTest() {
      var _this7 = this;

      var sExo = '';
      if (this.selectedPosition !== 'end') {
        sExo = this.selectedPosition + 1;
      }
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'addPartToTest',
          typeOfInsert: this.selectedPositionPart,
          position: this.selectedParts,
          id: this.$route.params.testId,
          quantity: this.numberOfNewParts,
          exercice: sExo
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        if (response.status === 200) {
          if (response.data.status === 'OK') {
            _this7.modalAddPartShown = false;
            _this7.loadTestData();
          } else {
            _this7.missingDataErrorShown = true;
            _this7.missingDataErrorMsg = _this7.$t('LNG_COULD_NOT_ADD_PARTS', _this7.lang);
          }
        }
      });
    },
    showRemovePartModal: function showRemovePartModal() {
      if (this.selectedParts === 'end') {
        this.modalErroMessageShown = true;
        this.errorMessage = this.$t('LNG_MISSING_PART_SELECTION', this.lang);
      } else {
        this.yesNoQuestion = this.$t('LNG_DO_YOU_WANT_TO_DELETE_PART', this.lang);
        this.yesNoTitle = this.$t('LNG_DO_YOU_WANT_TO_CONTINUE', this.lang);
        this.yesNoModalType = 'removePart';
        this.yesNoModalShown = !this.yesNoModalShown;
      }
    },
    removeSelectedPart: function removeSelectedPart() {
      var _this8 = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'removePartFromTest',
          part: this.selectedParts,
          id: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        if (response.status === 200) {
          if (response.data.status === 'OK') {
            _this8.loadTestData();
          } else {
            _this8.modalErroMessageShown = true;
            _this8.errorMessage = _this8.$t('LNG_COULD_NOT_REMOVE_PART', _this8.lang);
          }
        }
      });
    },
    howManyObjectivesToAdd: function howManyObjectivesToAdd() {
      if (this.selectedParts === 'end') {
        this.modalErroMessageShown = true;
        this.errorMessage = this.$t('LNG_MISSING_PART_SELECTION', this.lang);
        return;
      }

      this.modalAddObjectivesShown = true;
    },
    addNewObjectivesToTest: function addNewObjectivesToTest() {
      var _this9 = this;

      if (this.selectedParts === 'end') {
        this.modalErroMessageShown = true;
        this.errorMessage = this.$t('LNG_MISSING_PART_SELECTION', this.lang);
      } else {
        this.axios({
          method: 'post',
          url: this.api,
          data: {
            method: 'addObjectiveToPartInTest',
            part: this.selectedParts,
            id: this.$route.params.testId,
            quantity: this.numberOfNewObjectives
          },
          transformRequest: [function (data) {
            var qs = __webpack_require__(2);
            return qs.stringify(data, { arrayFormat: 'brackets' });
          }]
        }).then(function (response) {
          if (response.status === 200) {
            if (response.data.status === 'OK') {
              _this9.loadTestData();
              _this9.modalAddObjectivesShown = false;
            } else {
              _this9.modalErroMessageShown = true;
              _this9.errorMessage = _this9.$t('LNG_COULD_NOT_ADD_OBJECTIVE', _this9.lang);
            }
          }
        });
      }
    },
    selectObjective: function selectObjective(exoId) {
      if (this.selectedPosition !== 'end') {
        this.exerciceIsSelected[this.selectedPosition] = !this.exerciceIsSelected[this.selectedPosition];
        this.selectedPosition = 'end';
      }

      if (this.selectedParts !== 'end') {
        this.partIsSelected[this.selectedParts] = false;
        this.selectedPart = 'end';
      }
      if (exoId === this.selectedObjective) {
        this.selectedObjective = 0;
        this.objectiveIsSelected[exoId] = false;
      } else {
        this.objectiveIsSelected[this.selectedObjective] = false;
        this.objectiveIsSelected[exoId] = true;
        this.selectedObjective = exoId;
      }
      this.$forceUpdate();
    },
    showRemoveObjectiveModal: function showRemoveObjectiveModal() {
      if (this.selectedObjective === 0) {
        this.modalErroMessageShown = true;
        this.errorMessage = this.$t('LNG_MISSING_OBJECTIVE_SELECTION', this.lang);
      } else {
        this.yesNoQuestion = this.$t('LNG_DO_YOU_WANT_TO_DELETE_OBJECTIVE', this.lang);
        this.yesNoTitle = this.$t('LNG_DO_YOU_WANT_TO_CONTINUE', this.lang);
        this.yesNoModalType = 'removeObjective';
        this.yesNoModalShown = !this.yesNoModalShown;
      }
    },
    removeSelectedObjective: function removeSelectedObjective() {
      var _this10 = this;

      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'removeSelectedObjective',
          exercice: this.selectedObjective,
          id: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        if (response.status === 200) {
          if (response.data.status === 'OK') {
            _this10.loadTestData();
          } else {
            _this10.modalErroMessageShown = true;
            _this10.errorMessage = _this10.$t('LNG_COULD_NOT_REMOVE_OBJECTIVE', _this10.lang);
          }
        }
      });
    },
    chooseObjective: function chooseObjective(exoId, objId) {
      this.exerciceIdToLinkObj = exoId;
      this.modalObjectiveSelectionShown = true;
      var label = '';
      this.objectifsList.forEach(function (e) {
        if (e.value === objId) {
          label = e.label;
        }
      }, this);
      if (objId !== null) {
        this.selectedObjectiveInList = { value: objId, label: label };
      }

      this.$refs.objectifsListRef.$refs.search.focus();
    },
    affectObjective: function affectObjective() {
      var _this11 = this;

      if (this.selectedObjectiveInList === null && this.newObjectiveText === '') {
        this.modalErroMessageShown = true;
        this.errorMessage = this.$t('LNG_YOU_MUST_SELECT_AN_OBJ_OR_TYPE_ONE', this.lang);
        return;
      }

      if (this.selectedObjectiveInList !== null && this.newObjectiveText !== '') {
        this.modalErroMessageShown = true;
        this.errorMessage = this.$t('LNG_YOU_MUST_SELECT_AN_OBJ_OR_A_TYPE_ONE', this.lang);
        return;
      }

      var selection;
      if (this.selectedObjectiveInList == null) {
        selection = -1;
      } else {
        selection = this.selectedObjectiveInList.value;
      }
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'affectObjective',
          exercice: this.exerciceIdToLinkObj,
          id: this.$route.params.testId,
          text: this.newObjectiveText,
          selection: selection
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        if (response.status === 200) {
          if (response.data.status === 'OK') {
            _this11.modalObjectiveSelectionShown = false;
            _this11.newObjectiveText = '';
            _this11.selectedObjectiveInList = null;
            _this11.loadTestData();
            _this11.loadObjectivesList();
          } else {
            _this11.modalErroMessageShown = true;
            _this11.errorMessage = _this11.$t('LNG_OBJECTIVE_COULD_NOT_BE_AFFECTED', _this11.lang);
          }
        }
      });
    },

    uploadFileMenu: function uploadFileMenu() {
      this.wordFile = null;
      this.pdfFile = null;
      this.fileUploadTestModalShown = true;
    },
    importObjectivesMenu: function importObjectivesMenu(event) {
      var _this12 = this;

      if (this.$store.getters.licence === '1') {
        this.spinnerModalShown = true;
        this.progressBarValue = 0;
        this.progressBarTimeout = window.setInterval(this.progressBarUpload, 200);
        this.axios({
          method: 'post',
          url: this.api,
          data: {
            method: 'importObjectives',
            id: this.$route.params.testId
          },
          transformRequest: [function (data) {
            var qs = __webpack_require__(2);
            return qs.stringify(data, { arrayFormat: 'brackets' });
          }]
        }).then(function (response) {
          if (response.data.status === 'OK') {
            _this12.progressBarValue = 100;
            _this12.spinnerModalShown = false;
            clearInterval(_this12.progressBarTimeout);
            _this12.sucessAlertMessage = _this12.$t('LNG_OBJECTIVES_EXTRACTED', _this12.lang);
            _this12.successAlertShown = _this12.dismissSecs;
            _this12.loadTestData();
          } else {
            _this12.errorMessage = _this12.$t('LNG_OBJECTIVES_NOT_EXTRACTED', _this12.lang);
            _this12.modalErroMessageShown = !_this12.modalErroMessageShown;
          }
        });
      } else {
        this.showAlertNoLicence = true;
      }
    },
    enterResultsMenu: function enterResultsMenu() {
      this.$router.push({ path: '/results/' + this.$route.params.testId });
    },
    enterBaremeMenu: function enterBaremeMenu() {
      this.$router.push({ path: '/bareme/' + this.$route.params.testId });
    },
    printReportMenu: function printReportMenu() {
      var _this13 = this;

      this.spinnerModalShown = true;
      this.progressBarValue = 0;
      this.progressBarTimeout = setInterval(this.progressBarUpload, 800);
      if (this.$store.getters.licence === '1') {
        this.axios({
          method: 'post',
          url: this.api,
          data: {
            method: 'createPdf',
            testId: this.$route.params.testId
          },
          transformRequest: [function (data) {
            var qs = __webpack_require__(2);
            return qs.stringify(data, { arrayFormat: 'brackets' });
          }]
        }).then(function (response) {
          _this13.progressBarValue = 100;
          _this13.spinnerModalShown = false;
          clearInterval(_this13.progressBarTimeout);
          window.open(_this13.api + '?method=getPdf&name=' + response.data.name);
        });
      } else {
        this.showAlertNoLicence = true;
      }
    },
    printStudentGradeMenu: function printStudentGradeMenu() {
      var _this14 = this;

      this.spinnerModalShown = true;
      this.progressBarValue = 0;
      this.progressBarTimeout = setInterval(this.progressBarUpload, 800);
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'createPdfStudentGrade',
          testId: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        _this14.progressBarValue = 100;
        _this14.spinnerModalShown = false;
        clearInterval(_this14.progressBarTimeout);
        window.open(_this14.api + '?method=getPdf&name=' + response.data.name + '&clientname=notes');
      });
    },
    printGroupFormationMenu: function printGroupFormationMenu() {
      var _this15 = this;

      this.spinnerModalShown = true;
      this.progressBarValue = 0;
      this.progressBarTimeout = setInterval(this.progressBarUpload, 800);
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'printGroupFormation',
          testId: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        _this15.progressBarValue = 100;
        _this15.spinnerModalShown = false;
        clearInterval(_this15.progressBarTimeout);
        window.open(_this15.api + '?method=getPdf&name=' + response.data.name + '&clientname=groupes');
      });
    },
    printCommentsMenu: function printCommentsMenu() {
      var _this16 = this;

      this.spinnerModalShown = true;
      this.progressBarValue = 0;
      this.progressBarTimeout = setInterval(this.progressBarUpload, 800);
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'printComments',
          testId: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = __webpack_require__(2);
          return qs.stringify(data, { arrayFormat: 'brackets' });
        }]
      }).then(function (response) {
        _this16.progressBarValue = 100;
        _this16.spinnerModalShown = false;
        clearInterval(_this16.progressBarTimeout);
        window.open(_this16.api + '?method=getPdf&name=' + response.data.name + '&clientname=commentaires');
      });
    }
  }
});

/***/ }),

/***/ 794:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 795:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 796:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 797:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 798:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 799:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 800:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 801:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 802:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 803:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 804:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 805:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 806:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 807:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 808:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 809:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 810:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 811:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 812:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 813:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 814:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 815:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 816:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 817:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 818:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 819:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 243,
	"./af.js": 243,
	"./ar": 250,
	"./ar-dz": 244,
	"./ar-dz.js": 244,
	"./ar-kw": 245,
	"./ar-kw.js": 245,
	"./ar-ly": 246,
	"./ar-ly.js": 246,
	"./ar-ma": 247,
	"./ar-ma.js": 247,
	"./ar-sa": 248,
	"./ar-sa.js": 248,
	"./ar-tn": 249,
	"./ar-tn.js": 249,
	"./ar.js": 250,
	"./az": 251,
	"./az.js": 251,
	"./be": 252,
	"./be.js": 252,
	"./bg": 253,
	"./bg.js": 253,
	"./bm": 254,
	"./bm.js": 254,
	"./bn": 255,
	"./bn.js": 255,
	"./bo": 256,
	"./bo.js": 256,
	"./br": 257,
	"./br.js": 257,
	"./bs": 258,
	"./bs.js": 258,
	"./ca": 259,
	"./ca.js": 259,
	"./cs": 260,
	"./cs.js": 260,
	"./cv": 261,
	"./cv.js": 261,
	"./cy": 262,
	"./cy.js": 262,
	"./da": 263,
	"./da.js": 263,
	"./de": 266,
	"./de-at": 264,
	"./de-at.js": 264,
	"./de-ch": 265,
	"./de-ch.js": 265,
	"./de.js": 266,
	"./dv": 267,
	"./dv.js": 267,
	"./el": 268,
	"./el.js": 268,
	"./en-SG": 269,
	"./en-SG.js": 269,
	"./en-au": 270,
	"./en-au.js": 270,
	"./en-ca": 271,
	"./en-ca.js": 271,
	"./en-gb": 272,
	"./en-gb.js": 272,
	"./en-ie": 273,
	"./en-ie.js": 273,
	"./en-il": 274,
	"./en-il.js": 274,
	"./en-nz": 275,
	"./en-nz.js": 275,
	"./eo": 276,
	"./eo.js": 276,
	"./es": 279,
	"./es-do": 277,
	"./es-do.js": 277,
	"./es-us": 278,
	"./es-us.js": 278,
	"./es.js": 279,
	"./et": 280,
	"./et.js": 280,
	"./eu": 281,
	"./eu.js": 281,
	"./fa": 282,
	"./fa.js": 282,
	"./fi": 283,
	"./fi.js": 283,
	"./fo": 284,
	"./fo.js": 284,
	"./fr": 287,
	"./fr-ca": 285,
	"./fr-ca.js": 285,
	"./fr-ch": 286,
	"./fr-ch.js": 286,
	"./fr.js": 287,
	"./fy": 288,
	"./fy.js": 288,
	"./ga": 289,
	"./ga.js": 289,
	"./gd": 290,
	"./gd.js": 290,
	"./gl": 291,
	"./gl.js": 291,
	"./gom-latn": 292,
	"./gom-latn.js": 292,
	"./gu": 293,
	"./gu.js": 293,
	"./he": 294,
	"./he.js": 294,
	"./hi": 295,
	"./hi.js": 295,
	"./hr": 296,
	"./hr.js": 296,
	"./hu": 297,
	"./hu.js": 297,
	"./hy-am": 298,
	"./hy-am.js": 298,
	"./id": 299,
	"./id.js": 299,
	"./is": 300,
	"./is.js": 300,
	"./it": 302,
	"./it-ch": 301,
	"./it-ch.js": 301,
	"./it.js": 302,
	"./ja": 303,
	"./ja.js": 303,
	"./jv": 304,
	"./jv.js": 304,
	"./ka": 305,
	"./ka.js": 305,
	"./kk": 306,
	"./kk.js": 306,
	"./km": 307,
	"./km.js": 307,
	"./kn": 308,
	"./kn.js": 308,
	"./ko": 309,
	"./ko.js": 309,
	"./ku": 310,
	"./ku.js": 310,
	"./ky": 311,
	"./ky.js": 311,
	"./lb": 312,
	"./lb.js": 312,
	"./lo": 313,
	"./lo.js": 313,
	"./lt": 314,
	"./lt.js": 314,
	"./lv": 315,
	"./lv.js": 315,
	"./me": 316,
	"./me.js": 316,
	"./mi": 317,
	"./mi.js": 317,
	"./mk": 318,
	"./mk.js": 318,
	"./ml": 319,
	"./ml.js": 319,
	"./mn": 320,
	"./mn.js": 320,
	"./mr": 321,
	"./mr.js": 321,
	"./ms": 323,
	"./ms-my": 322,
	"./ms-my.js": 322,
	"./ms.js": 323,
	"./mt": 324,
	"./mt.js": 324,
	"./my": 325,
	"./my.js": 325,
	"./nb": 326,
	"./nb.js": 326,
	"./ne": 327,
	"./ne.js": 327,
	"./nl": 329,
	"./nl-be": 328,
	"./nl-be.js": 328,
	"./nl.js": 329,
	"./nn": 330,
	"./nn.js": 330,
	"./pa-in": 331,
	"./pa-in.js": 331,
	"./pl": 332,
	"./pl.js": 332,
	"./pt": 334,
	"./pt-br": 333,
	"./pt-br.js": 333,
	"./pt.js": 334,
	"./ro": 335,
	"./ro.js": 335,
	"./ru": 336,
	"./ru.js": 336,
	"./sd": 337,
	"./sd.js": 337,
	"./se": 338,
	"./se.js": 338,
	"./si": 339,
	"./si.js": 339,
	"./sk": 340,
	"./sk.js": 340,
	"./sl": 341,
	"./sl.js": 341,
	"./sq": 342,
	"./sq.js": 342,
	"./sr": 344,
	"./sr-cyrl": 343,
	"./sr-cyrl.js": 343,
	"./sr.js": 344,
	"./ss": 345,
	"./ss.js": 345,
	"./sv": 346,
	"./sv.js": 346,
	"./sw": 347,
	"./sw.js": 347,
	"./ta": 348,
	"./ta.js": 348,
	"./te": 349,
	"./te.js": 349,
	"./tet": 350,
	"./tet.js": 350,
	"./tg": 351,
	"./tg.js": 351,
	"./th": 352,
	"./th.js": 352,
	"./tl-ph": 353,
	"./tl-ph.js": 353,
	"./tlh": 354,
	"./tlh.js": 354,
	"./tr": 355,
	"./tr.js": 355,
	"./tzl": 356,
	"./tzl.js": 356,
	"./tzm": 358,
	"./tzm-latn": 357,
	"./tzm-latn.js": 357,
	"./tzm.js": 358,
	"./ug-cn": 359,
	"./ug-cn.js": 359,
	"./uk": 360,
	"./uk.js": 360,
	"./ur": 361,
	"./ur.js": 361,
	"./uz": 363,
	"./uz-latn": 362,
	"./uz-latn.js": 362,
	"./uz.js": 363,
	"./vi": 364,
	"./vi.js": 364,
	"./x-pseudo": 365,
	"./x-pseudo.js": 365,
	"./yo": 366,
	"./yo.js": 366,
	"./zh-cn": 367,
	"./zh-cn.js": 367,
	"./zh-hk": 368,
	"./zh-hk.js": 368,
	"./zh-tw": 369,
	"./zh-tw.js": 369
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 844;

/***/ }),

/***/ 857:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(799)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(874),
  /* scopeId */
  "data-v-2ae45c0a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 858:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(802)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(876),
  /* scopeId */
  "data-v-2d4225cc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 859:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(810)
__webpack_require__(809)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(880),
  /* scopeId */
  "data-v-6d54466e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 860:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(818)
__webpack_require__(817)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(884),
  /* scopeId */
  "data-v-cfd9fdc6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 861:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(816)
__webpack_require__(815)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(883),
  /* scopeId */
  "data-v-af66f892",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 862:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(806)
__webpack_require__(805)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(878),
  /* scopeId */
  "data-v-519ccf5c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 863:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(797)
__webpack_require__(796)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(872),
  /* scopeId */
  "data-v-209ab88c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 864:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(812)
__webpack_require__(811)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(881),
  /* scopeId */
  "data-v-6fe3536e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 865:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(808)
__webpack_require__(807)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(879),
  /* scopeId */
  "data-v-63276f70",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 866:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(795)
__webpack_require__(794)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(871),
  /* scopeId */
  "data-v-11057832",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 867:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(819)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(885),
  /* scopeId */
  "data-v-ecfcb0a0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 868:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(814)
__webpack_require__(813)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(882),
  /* scopeId */
  "data-v-7b8c0107",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 869:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(801)
__webpack_require__(800)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(875),
  /* scopeId */
  "data-v-2c2bb060",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 870:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(804)
__webpack_require__(803)

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(877),
  /* scopeId */
  "data-v-420ab3fb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 871:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('LNG_MAINVIEW_TITLE', this.lang)))])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 872:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "managementKnowledge container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2 col-md-2 col-sd-12 col-xs-12"
  }, [_c('div', {
    staticClass: "syscofixed hidden-xs hidden-sm"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageSrc,
      "width": "100%"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10 col-md-10 col-sd-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v(_vm._s(_vm.$t('LNG_EVALUATION_INFORMATION', this.lang)))]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sd-12 col-xs-12",
    attrs: {
      "id": "testContent"
    }
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('LNG_NAME', this.lang)) + ": " + _vm._s(this.testName)), _c('br'), _vm._v(_vm._s(_vm.$t('LNG_DISCIPLINE', this.lang)) + ": " + _vm._s(this.testDiscipline)), _c('br'), _vm._v(_vm._s(_vm.$t('LNG_DATE', this.lang)) + ": " + _vm._s(this.testDate))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sd-12 col-xs-12",
    attrs: {
      "id": "testContent"
    }
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('span', [_c('pre', [_vm._v(_vm._s(this.testComment))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sd-12 col-xs-12"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', {}, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('LNG_EXERCICES', this.lang)))]), _vm._v(" "), _c('th', [_c('div', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.$t('LNG_OBJECTIVES', this.lang)))])]), _vm._v(" "), _c('th', [_c('div', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('LNG_CATEGORY', this.lang)))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.exercices), function(exercice) {
    return _vm._l((exercice.objectifs), function(objectif, index) {
      return _c('tr', [_c('th', {
        attrs: {
          "scope": "row"
        }
      }, [_vm._v(_vm._s(exercice.id) + _vm._s(objectif.part))]), _vm._v(" "), _c('td', {
        attrs: {
          "width": "60%"
        }
      }, [_c('p', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(objectif.objectif))])]), _vm._v(" "), _c('td', [_c('button-group', {
        model: {
          value: (_vm.checkboxValue[objectif.exoId]),
          callback: function($$v) {
            _vm.$set(_vm.checkboxValue, objectif.exoId, $$v)
          },
          expression: "checkboxValue[objectif.exoId]"
        }
      }, [_c('radio', {
        attrs: {
          "selected-value": "declaratif"
        },
        on: {
          "checked": function($event) {
            return _vm.chkClicked(objectif.exoId, 'declaratif')
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('LNG_DECLARATIVE_KNOWLEDGE', this.lang)))]), _vm._v(" "), _c('radio', {
        attrs: {
          "selected-value": "procedural"
        },
        on: {
          "checked": function($event) {
            return _vm.chkClicked(objectif.exoId, 'procedural')
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('LNG_PROCESSUS_KNOWLEDGE', this.lang)))]), _vm._v(" "), _c('radio', {
        attrs: {
          "selected-value": "pratique"
        },
        on: {
          "checked": function($event) {
            return _vm.chkClicked(objectif.exoId, 'pratique')
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('LNG_PRACTICAL_KNOWLEDGE', this.lang)))])], 1)], 1)])
    })
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2 col-md-2 col-sd-12 col-xs-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sd-12 col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-lg btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.back()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-arrow-left"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_BACK', this.lang)))])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 873:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    class: {
      toggled: _vm.isSideBarVisible
    },
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    attrs: {
      "id": "sidebar-wrapper"
    }
  }, [_c('ul', {
    staticClass: "sidebar-nav"
  }, [_vm._m(0), _vm._v(" "), _c('li', [_vm._v("\n               Exercices\n           ")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$refs.childApplication.showAddExerciceModal()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus fa-lg"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$refs.childApplication.showRemoveExerciceModal()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-minus fa-lg"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$refs.childApplication.toggleAllExercices()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-sort-up fa-lg"
  })])]), _vm._v(" "), _c('li', [_vm._v("\n                \n           ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$refs.childApplication.showAddPartModal()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus fa-lg"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$refs.childApplication.showRemovePartModal()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-minus fa-lg"
  })])]), _vm._v(" "), _c('li', [_vm._v("\n                \n           ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$refs.childApplication.howManyObjectivesToAdd()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus fa-lg"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$refs.childApplication.showRemoveObjectiveModal()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-minus fa-lg"
  })])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "id": "page-content-wrapper"
    }
  }, [(this.isAuthenticated) ? _c('div', {
    staticClass: "mb-3"
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "md",
      "type": "dark",
      "variant": "evaobj"
    }
  }, [_c('b-navbar-toggle', {
    attrs: {
      "target": "nav_collapse"
    }
  }), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("EvaObj - Évaluation par objectifs")]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [(this.isAuthenticated && (_vm.$route.path.indexOf('testEdit') !== -1 || _vm.$route.path.indexOf('results') !== -1 || _vm.$route.path.indexOf('bareme') !== -1)) ? _c('b-nav-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-long-arrow-left fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_BACK', _vm.lang)))]) : _vm._e(), _vm._v(" "), (this.isAuthenticated && (_vm.$route.path.indexOf('managementStudentsGroups') !== -1 || _vm.$route.path.indexOf('ManagementCenter') !== -1 || _vm.$route.path.indexOf('ManagementDiscipline') !== -1 || _vm.$route.path.indexOf('managementTeacher') !== -1)) ? _c('b-nav-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-long-arrow-left fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_BACK', _vm.lang)))]) : _vm._e(), _vm._v(" "), (this.isAuthenticated && (_vm.$route.path.indexOf('managementStudentsGroups') !== -1)) ? _c('b-nav-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.addStudent()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-user fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_ADD_STUDENT', _vm.lang)))]) : _vm._e(), _vm._v(" "), (this.isAuthenticated && (_vm.$route.path.indexOf('mainview') !== -1) && this.adminLevel < 2) ? _c('b-nav-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.showAddTest()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-file fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_ADD_TEST', _vm.lang)))]) : _vm._e(), _vm._v(" "), (this.isAuthenticated && (_vm.$route.path.indexOf('ManagementCenter') !== -1) && this.adminLevel >= 4) ? _c('b-nav-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.addCenter()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-building-o fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_NEW_CENTER', _vm.lang)))]) : _vm._e(), _vm._v(" "), (this.isAuthenticated && (_vm.$route.path.indexOf('ManagementDiscipline') !== -1)) ? _c('b-nav-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.addDiscipline()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-comment-o fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_NEW_DISCIPLINE', _vm.lang)))]) : _vm._e(), _vm._v(" "), (this.isAuthenticated && (_vm.$route.path.indexOf('managementTeacher') !== -1)) ? _c('b-nav-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.addTeacher()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-address-card fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_NEW_TEACHER', _vm.lang)))]) : _vm._e(), _vm._v(" "), (this.$route.params.testId >= 1 && _vm.$route.path.indexOf('test') !== -1) ? _c('b-nav-item-dropdown', {
    attrs: {
      "text": _vm.$t('LNG_TEST_MANAGEMENT', this.lang),
      "right": ""
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-upload fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_UPLOAD', _vm.lang)))]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.importObjectives()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-shopping-cart fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_IMPORT_OBJECTIVES', _vm.lang)))]), _vm._v(" "), (false) ? _c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.gotoKnowledgeManagement()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-lightbulb-o fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_MANAGE_KNOWLEDGE', _vm.lang)))]) : _vm._e(), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.enterResultsMenu()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-signal fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_NOTES', _vm.lang)))]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.enterBaremeMenu()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-balance-scale fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_BAREME', _vm.lang)))]), _vm._v(" "), (_vm.$route.path.indexOf('test') !== -1) ? _c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.printReport()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-print fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_PRINT_RESULTS', _vm.lang)))]) : _vm._e(), _vm._v(" "), (_vm.$route.path.indexOf('test') !== -1) ? _c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.printComments()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-print fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_PRINT_COMMENTS', _vm.lang)))]) : _vm._e(), _vm._v(" "), (_vm.$route.path.indexOf('test') !== -1) ? _c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.printStudentGrade()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-print fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_STUDENT_GRADE', _vm.lang)))]) : _vm._e(), _vm._v(" "), (_vm.$route.path.indexOf('test') !== -1) ? _c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.printGroupFormation()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-print fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_PRINT_GROUPE_FORMATION', _vm.lang)))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.isAuthenticated && _vm.$route.path.indexOf('mainview') !== -1 && this.adminLevel < 4) ? _c('b-nav-item-dropdown', {
    attrs: {
      "text": _vm.$t('LNG_STUDENTS_MANAGEMENT', this.lang),
      "right": ""
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.gotoShowModal()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-graduation-cap fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_STUDENTS', _vm.lang)))]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.gotoStudentManagement()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-user fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_STUDENTS_MANAGEMENT', _vm.lang)))])], 1) : _vm._e(), _vm._v(" "), (this.isAuthenticated && this.adminLevel >= 2) ? _c('b-nav-item-dropdown', {
    attrs: {
      "text": _vm.$t('LNG_ADMINISTRATION', this.lang),
      "right": ""
    }
  }, [(this.adminLevel & 2 || (this.adminLevel & 4)) ? _c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.gotoManagementCenter()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-building-o fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_CENTER_MANAGEMENT', _vm.lang)))]) : _vm._e(), _vm._v(" "), ((this.adminLevel & 2) || (this.adminLevel & 4)) ? _c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.gotoManagementTeacher()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-address-card fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_TEACHER_MANAGEMENT', _vm.lang)))]) : _vm._e(), _vm._v(" "), ((this.adminLevel & 2) || (this.adminLevel & 4)) ? _c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.gotoManagementDiscipline()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-comment-o fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_DISCIPLINE_MANAGEMENT', _vm.lang)))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.isAuthenticated) ? _c('b-nav-item-dropdown', {
    attrs: {
      "text": this.fullname,
      "right": ""
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "href": "#/changePassword"
    }
  }, [_c('span', {
    staticClass: "fa fa-lock fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_CHANGE_PASSWORD_BTN', _vm.lang)))]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-sign-out fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_LOGOUT_BTN', _vm.lang)))]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_VERSION', _vm.lang)))])], 1) : _vm._e(), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.support()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-question-circle fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_HELP', _vm.lang)))])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('router-view', {
    ref: "childApplication"
  })], 1), _vm._v(" "), _c('div', [_c('spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.spinner),
      expression: "spinner"
    }],
    ref: "spinner",
    attrs: {
      "global": "",
      "size": "50",
      "line-fg-color": "#97002D",
      "speed": 3,
      "line-size": 5
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "sidebar-brand"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Parties")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Objectifs ")])])
}]}

/***/ }),

/***/ 874:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-form', {
    on: {
      "submit": _vm.changePassword
    }
  }, [_c('b-row', {
    staticClass: "my-1"
  }, [_c('b-col', {
    attrs: {
      "sm": "3",
      "lg": "3"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "6"
    }
  }, [_c('img', {
    attrs: {
      "title": _vm.$t('LNG_TITLE', this.lang),
      "alt": _vm.$t('LNG_TITLE', this.lang),
      "width": "200px",
      "src": __webpack_require__(148)
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('LNG_CHANGE_PASSWORD', _vm.lang)))])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "my-1"
  }, [_c('b-col', {
    attrs: {
      "sm": "3",
      "lg": "4"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "4"
    }
  }, [_c('b-input-group', [_c('b-input-group-text', {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-at"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('LNG_NEW_PASSWORD', _vm.lang),
      "required": "",
      "autofocus": "",
      "autocapitalize": "off"
    },
    on: {
      "keydown": function($event) {
        return _vm.setErrorMessage('')
      }
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "my-1"
  }, [_c('b-col', {
    attrs: {
      "sm": "3",
      "lg": "4"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "4"
    }
  }, [_c('b-input-group', [_c('b-input-group-text', {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-at"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('LNG_NEW_PASSWORD_CONFIRM', _vm.lang),
      "required": "",
      "autocapitalize": "off"
    },
    on: {
      "keydown": function($event) {
        return _vm.setErrorMessage('')
      }
    },
    model: {
      value: (_vm.newPasswordConfirm),
      callback: function($$v) {
        _vm.newPasswordConfirm = $$v
      },
      expression: "newPasswordConfirm"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "my-3"
  }, [_c('b-col', {
    attrs: {
      "sm": "2",
      "lg": "4"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "5",
      "lg": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "evaobj",
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CONFIRM', _vm.lang)))])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "5",
      "lg": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "danger",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePasswordCancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CANCEL', _vm.lang)))])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('br'), _vm._v(" "), _c('p', {
    staticClass: "text-warning"
  }, [_vm._v(_vm._s(this.errorMessage))])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 875:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('LNG_SUPPORT', this.lang)))])])], 1), _vm._v(" "), (_vm.notSentError) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "8",
      "offset": "2"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_MESSAGE_NOT_SENT', this.lang)))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.notSent) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "8",
      "offset": "2"
    }
  }, [_c('b-form-textarea', {
    ref: "myMessage",
    staticClass: "mb-3",
    attrs: {
      "id": "myMessage",
      "placeholder": _vm.$t('LNG_YOUR_MESSAGE', this.lang),
      "rows": 10,
      "max-rows": 100
    },
    model: {
      value: (_vm.myMessage),
      callback: function($$v) {
        _vm.myMessage = $$v
      },
      expression: "myMessage"
    }
  }), _vm._v(" "), _c('vue-recaptcha', {
    attrs: {
      "sitekey": "6Lc6FFoUAAAAACPewmO49WouIZm6Jmim6TKKLLcE"
    },
    on: {
      "verify": _vm.okC
    }
  }), _vm._v(" "), (_vm.displaySendMessage) ? _c('b-button', {
    attrs: {
      "type": "button",
      "variant": "evaobj"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSubmit()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_SEND', _vm.lang)))]) : _vm._e(), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exit()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CLOSE', _vm.lang)))])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.notSent) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "8",
      "offset": "2"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "success",
      "show": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_MESSAGE_SENT', this.lang)))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exit()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CLOSE', _vm.lang)))])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-form', {
    on: {
      "submit": _vm.authenticate
    }
  }, [_c('b-row', {
    staticClass: "my-1"
  }, [_c('b-col', {
    attrs: {
      "sm": "3",
      "lg": "3"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "6"
    }
  }, [_c('img', {
    attrs: {
      "title": _vm.$t('LNG_TITLE', this.lang),
      "alt": _vm.$t('LNG_TITLE', this.lang),
      "width": "200px",
      "src": __webpack_require__(148)
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('LNG_WELCOME', _vm.lang)))])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "my-1"
  }, [_c('b-col', {
    attrs: {
      "sm": "3",
      "lg": "4"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6",
      "lg": "4"
    }
  }, [_c('b-input-group', [_c('b-input-group-text', {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-user"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": _vm.$t('LNG_EMAIL', _vm.lang),
      "required": "",
      "autofocus": "",
      "autocapitalize": "off"
    },
    on: {
      "keydown": function($event) {
        return _vm.setErrorMessage('')
      }
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "my-1"
  }, [_c('b-col', {
    attrs: {
      "sm": "3",
      "lg": "4"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "4"
    }
  }, [_c('b-input-group', [_c('b-input-group-text', {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-at"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('LNG_PASSWORD', _vm.lang),
      "required": "",
      "autofocus": "",
      "autocapitalize": "off"
    },
    on: {
      "keydown": function($event) {
        return _vm.setErrorMessage('')
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "my-3"
  }, [_c('b-col', {
    attrs: {
      "sm": "3",
      "lg": "4"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "4"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "evaobj",
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_LOGIN_BTN', _vm.lang)))])], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "my-3"
  }, [_c('b-col', {
    attrs: {
      "sm": "3",
      "lg": "4"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "4"
    }
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "link"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.recoverPassword()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_RECOVER_PASSWORD', _vm.lang)))])], 1)], 1)], 1), _vm._v(" "), (_vm.errorMessage !== '') ? _c('b-row', {
    staticClass: "my-1"
  }, [_c('b-col', {
    attrs: {
      "sm": "3",
      "lg": "4"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "4"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": ""
    }
  }, [_vm._v(_vm._s(this.errorMessage))])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 877:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "8",
      "offset": "1"
    }
  }, [(_vm.displayTestInfos) ? _c('b-row', {
    staticClass: "syscoBox text-left"
  }, [_c('b-col', {
    staticClass: "text-white bg-evaobj pt-2",
    attrs: {
      "cols": "12",
      "id": "testContent"
    }
  }, [_c('h5', [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.$t('LNG_EVALUATION_INFORMATION', this.lang)))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-edit text-left align-middle",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.displayTestInfos = !_vm.displayTestInfos
      }
    }
  })])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-3",
    attrs: {
      "cols": "12",
      "id": "testContent"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('LNG_NAME', this.lang)) + ": " + _vm._s(this.testName)), _c('br'), _vm._v(_vm._s(_vm.$t('LNG_DISCIPLINE', this.lang)) + ": " + _vm._s(this.testDiscipline)), _c('br'), _vm._v(_vm._s(_vm.$t('LNG_DATE', this.lang)) + ": " + _vm._s(_vm.testDateFormatted)), _c('br'), _c('br'), _vm._v("\n            " + _vm._s(_vm.$t('LNG_TOTAL_POINTS', this.lang)) + ": " + _vm._s(this.totalPoints))])]), _vm._v(" "), (this.testComment !== '') ? _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('span', [_c('pre', [_vm._v(_vm._s(this.testComment))])])]) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "8",
      "offset": "1"
    }
  }, [(!_vm.displayTestInfos) ? _c('b-row', {
    staticClass: "syscoBox text-left rounded"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "text-white bg-evaobj rounded",
    attrs: {
      "cols": "12"
    }
  }, [_c('h5', [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.$t('LNG_EDIT_EVALUATION_INFORMATION', this.lang)))])])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.missingDataErrorShown) ? _c('b-alert', {
    staticClass: "mt-2",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(this.missingDataErrorMsg))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_NAME', this.lang))), _c('b-form-input', {
    ref: "testName",
    staticClass: "mb-3",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": _vm.$t('LNG_NAME', this.lang)
    },
    model: {
      value: (_vm.testName),
      callback: function($$v) {
        _vm.testName = $$v
      },
      expression: "testName"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_DATE', this.lang))), _c('b-form-input', {
    staticClass: "mb-3",
    attrs: {
      "type": "date",
      "placeholder": _vm.$t('LNG_DATE', this.lang)
    },
    model: {
      value: (_vm.testDateBrut),
      callback: function($$v) {
        _vm.testDateBrut = $$v
      },
      expression: "testDateBrut"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_COMMENTS', this.lang))), _c('b-form-textarea', {
    staticClass: "mb-3",
    attrs: {
      "rows": "5",
      "id": "testComment",
      "placeholder": _vm.$t('LNG_TEST_COMMENTS', this.lang)
    },
    model: {
      value: (_vm.testComment),
      callback: function($$v) {
        _vm.testComment = $$v
      },
      expression: "testComment"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "1"
    }
  }, [_c('b-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.displayTestInfos = !_vm.displayTestInfos
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CLOSE', _vm.lang)))])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "1"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "evaobj",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveTestInformation()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_SAVE', _vm.lang)))])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "8",
      "offset": "1"
    }
  }, [_c('b-alert', {
    attrs: {
      "show": _vm.successAlertShown,
      "dismissible": "",
      "variant": "evaobj"
    },
    on: {
      "dismissed": function($event) {
        _vm.successAlertShown = 0
      },
      "dismiss-count-down": _vm.countDownChanged
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.sucessAlertMessage))])])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "8",
      "offset": "1"
    }
  }, _vm._l((_vm.exercices), function(exercice, indexe) {
    return _c('div', [_c('b-row', {
      staticClass: "border pt-2 pb-2",
      class: {
        'selectedExercice': _vm.exerciceIsSelected[indexe]
      },
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.selectExercice(indexe, $event)
        }
      }
    }, [_c('b-col', {
      staticClass: "text-left",
      attrs: {
        "cols": "11"
      }
    }, [_vm._v(_vm._s(_vm.$t('LNG_EXERCICE', this.lang)) + " " + _vm._s(exercice.exoNumber) + " "), _c('i', {
      staticClass: "fa fa-2x",
      class: {
        'fa-sort-down': !_vm.exerciceIsShown[indexe], 'fa-sort-up': _vm.exerciceIsShown[indexe], 'align-top': !_vm.exerciceIsShown[indexe]
      },
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.toggleExercice($event, indexe)
        }
      }
    })]), _vm._v(" "), _c('b-col', {
      staticClass: "text-right",
      attrs: {
        "cols": "1"
      }
    }, [_vm._v(_vm._s(_vm.totalByExo[indexe]['points']) + " " + _vm._s(_vm.$t('LNG_PTS', this.lang)))])], 1), _vm._v(" "), _vm._l((exercice.parts), function(part, indexePart) {
      return _c('div', [_c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [_c('b-row', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.exerciceIsShown[indexe]),
          expression: "exerciceIsShown[indexe]"
        }]
      }, [_c('b-col', {
        staticClass: "text-left",
        class: {
          'selectedExercice': _vm.partIsSelected[indexe * 100 + indexePart]
        },
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "cols": "11",
          "offset": "1"
        }
      }, [_c('b-row', {
        staticClass: "border pt-2",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.selectPart(indexe, indexePart)
          }
        }
      }, [_c('b-col', {
        attrs: {
          "cols": "10"
        }
      }, [_vm._v(_vm._s(_vm.$t('LNG_PART', this.lang)) + " " + _vm._s(part.partName))]), _vm._v(" "), _c('b-col', {
        staticClass: "text-right",
        attrs: {
          "cols": "2"
        }
      }, [_vm._v(_vm._s(_vm.totalByExo[indexe]['parts'][part.partName]) + " " + _vm._s(_vm.$t('LNG_PTS', this.lang)))])], 1)], 1)], 1)], 1), _vm._v(" "), _vm._l((part.exercices), function(exo, indexeExo) {
        return _c('div', [_c('transition', {
          attrs: {
            "name": "fade"
          }
        }, [_c('b-row', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.exerciceIsShown[indexe]),
            expression: "exerciceIsShown[indexe]"
          }]
        }, [_c('b-col', {
          staticClass: "text-left",
          attrs: {
            "cols": "10",
            "offset": "2"
          }
        }, [_c('b-row', {
          staticClass: "pt-1",
          class: {
            'border-objectifLight': indexeExo % 2 !== 0, 'border-objectif': indexeExo % 2 === 0, 'objective-selected': _vm.objectiveIsSelected[exo.exoId]
          },
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.selectObjective(exo.exoId)
            }
          }
        }, [_c('b-col', {
          attrs: {
            "cols": "10"
          }
        }, [_c('span', {
          staticClass: "fa fa-edit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.chooseObjective(exo.exoId, exo.objId)
            }
          }
        }), _vm._v(" " + _vm._s(exo.obj))]), _vm._v(" "), _c('b-col', {
          staticClass: "pb-1 pt-1",
          attrs: {
            "cols": "2"
          }
        }, [_c('b-form-input', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.left",
            value: (_vm.$t('LNG_POINTS', this.lang)),
            expression: "$t('LNG_POINTS', this.lang)",
            modifiers: {
              "hover": true,
              "left": true
            }
          }],
          attrs: {
            "type": "text",
            "size": "sm",
            "value": exo.pts
          },
          on: {
            "change": function($event) {
              return _vm.pointsChanged(exo.exoId, exo.pts)
            }
          },
          model: {
            value: (exo.pts),
            callback: function($$v) {
              _vm.$set(exo, "pts", $$v)
            },
            expression: "exo.pts"
          }
        })], 1)], 1)], 1)], 1)], 1)], 1)
      })], 2)
    })], 2)
  }), 0)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-modal', {
    attrs: {
      "centered": "",
      "title": _vm.yesNoTitle
    },
    model: {
      value: (_vm.yesNoModalShown),
      callback: function($$v) {
        _vm.yesNoModalShown = $$v
      },
      expression: "yesNoModalShown"
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.yesNoQuestion))])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-button', {
    attrs: {
      "type": "button",
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.yesNoModalShown = !_vm.yesNoModalShown
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_NO', _vm.lang)))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "button",
      "variant": "evaobj"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.yesNoModal_YES()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_YES', _vm.lang)))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "centered": ""
    },
    model: {
      value: (_vm.modalAddExerciceShown),
      callback: function($$v) {
        _vm.modalAddExerciceShown = $$v
      },
      expression: "modalAddExerciceShown"
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('col', {
    attrs: {
      "cols": "2"
    }
  }), _vm._v("Ajouter "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-input', {
    attrs: {
      "size": "sm",
      "type": "number",
      "value": "1",
      "min": "1"
    },
    model: {
      value: (_vm.numberOfNewExercice),
      callback: function($$v) {
        _vm.numberOfNewExercice = $$v
      },
      expression: "numberOfNewExercice"
    }
  })], 1), _vm._v(" exercice"), (_vm.numberOfNewExercice > 1) ? _c('span', [_vm._v("s ")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t('LNG_ADD_THE_EXERCICE_AT', this.lang)))]), _vm._v(" "), _c('b-form-group', [_c('b-form-radio-group', {
    attrs: {
      "name": "radioInline"
    },
    model: {
      value: (_vm.selectedPosition),
      callback: function($$v) {
        _vm.selectedPosition = $$v
      },
      expression: "selectedPosition"
    }
  }, [_vm._l((_vm.exercices), function(exercice, indexe) {
    return _c('div', [_c('b-form-radio', {
      attrs: {
        "value": indexe
      }
    }, [_vm._v(_vm._s(indexe + 1))])], 1)
  }), _vm._v(" "), _c('b-form-radio', {
    attrs: {
      "value": "end"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_AT_THEN_END', this.lang)))])], 2)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.modalAddExerciceShown = !_vm.modalAddExerciceShown
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CLOSE', _vm.lang)))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "evaobj",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addNewExerciceToTest(_vm.selectedPosition)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_ADD', _vm.lang)))])], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "centered": "",
      "title": _vm.$t('LNG_ERROR', this.lang),
      "header-bg-variant": "danger",
      "header-text-variant": "light"
    },
    model: {
      value: (_vm.modalErroMessageShown),
      callback: function($$v) {
        _vm.modalErroMessageShown = $$v
      },
      expression: "modalErroMessageShown"
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.errorMessage))])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-button', {
    attrs: {
      "type": "button",
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.modalErroMessageShown = !_vm.modalErroMessageShown
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_OK', _vm.lang)))])], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "centered": "",
      "title": _vm.$t('LNG_JOIN_TEST', this.lang)
    },
    model: {
      value: (_vm.fileUploadTestModalShown),
      callback: function($$v) {
        _vm.fileUploadTestModalShown = $$v
      },
      expression: "fileUploadTestModalShown"
    }
  }, [(_vm.displayUploadAlert) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n      " + _vm._s(this.uploadedFileErroMessage) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.$t('LNG_PLEASE_SELECT_A_FILE_WORD', this.lang)))]), _vm._v(" "), _c('b-form-file', {
    ref: "fileinputword",
    staticClass: "mb-4",
    attrs: {
      "accept": ".docx",
      "state": Boolean(_vm.wordFile),
      "placeholder": _vm.$t('LNG_WORD_FILE', _vm.lang)
    },
    model: {
      value: (_vm.wordFile),
      callback: function($$v) {
        _vm.wordFile = $$v
      },
      expression: "wordFile"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.$t('LNG_PLEASE_SELECT_A_FILE_PDF', this.lang)))]), _vm._v(" "), _c('b-form-file', {
    ref: "fileinputpdf",
    attrs: {
      "accept": ".pdf",
      "state": Boolean(_vm.pdfFile),
      "placeholder": _vm.$t('LNG_PDF_FILE', _vm.lang)
    },
    model: {
      value: (_vm.pdfFile),
      callback: function($$v) {
        _vm.pdfFile = $$v
      },
      expression: "pdfFile"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.fileUploadTestModalShown = !_vm.fileUploadTestModalShown
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CANCEL', this.lang)))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "button",
      "variant": "evaobj"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.uploadFileTest()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_ADD', this.lang)))])], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "centered": ""
    },
    model: {
      value: (_vm.spinnerModalShown),
      callback: function($$v) {
        _vm.spinnerModalShown = $$v
      },
      expression: "spinnerModalShown"
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-progress', {
    staticClass: "mb-2",
    attrs: {
      "value": _vm.progressBarValue,
      "variant": "success",
      "striped": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "centered": ""
    },
    model: {
      value: (_vm.modalAddPartShown),
      callback: function($$v) {
        _vm.modalAddPartShown = $$v
      },
      expression: "modalAddPartShown"
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('col', {
    attrs: {
      "cols": "2"
    }
  }), _vm._v(_vm._s(_vm.$t('LNG_ADD', _vm.lang)) + " "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-input', {
    attrs: {
      "size": "sm",
      "type": "number",
      "value": "1",
      "min": "1"
    },
    model: {
      value: (_vm.numberOfNewParts),
      callback: function($$v) {
        _vm.numberOfNewParts = $$v
      },
      expression: "numberOfNewParts"
    }
  })], 1), _vm._v(_vm._s(_vm.$t('LNG_PART_SMALL', _vm.lang))), (_vm.numberOfNewParts > 1) ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v(" "), (_vm.selectedParts !== 'end') ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('LNG_ADD_THE_PART_AT', this.lang)))]) : _vm._e()]), _vm._v(" "), _c('b-form-group', [_c('b-form-radio-group', {
    attrs: {
      "name": "radioInline"
    },
    model: {
      value: (_vm.selectedPositionPart),
      callback: function($$v) {
        _vm.selectedPositionPart = $$v
      },
      expression: "selectedPositionPart"
    }
  }, [(_vm.selectedParts !== 'end') ? _c('b-row', [_c('b-form-radio', {
    attrs: {
      "value": "selected"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_SELECTED_PART', _vm.lang)))])], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-form-radio', {
    attrs: {
      "value": "end"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_AT_THEN_END', _vm.lang)))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.modalAddPartShown = !_vm.modalAddPartShown
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CLOSE', _vm.lang)))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "evaobj",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addNewPartToTest()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_ADD', _vm.lang)))])], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "centered": ""
    },
    model: {
      value: (_vm.modalAddObjectivesShown),
      callback: function($$v) {
        _vm.modalAddObjectivesShown = $$v
      },
      expression: "modalAddObjectivesShown"
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('col', {
    attrs: {
      "cols": "2"
    }
  }), _vm._v(_vm._s(_vm.$t('LNG_ADD', _vm.lang)) + " "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-input', {
    attrs: {
      "size": "sm",
      "type": "number",
      "value": "1",
      "min": "1"
    },
    model: {
      value: (_vm.numberOfNewObjectives),
      callback: function($$v) {
        _vm.numberOfNewObjectives = $$v
      },
      expression: "numberOfNewObjectives"
    }
  })], 1), _vm._v(" " + _vm._s(_vm.$t('LNG_OBJECTIVE_SMALL', _vm.lang))), (_vm.numberOfNewObjectives > 1) ? _c('span', [_vm._v("s ")]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.modalAddObjectivesShown = !_vm.modalAddObjectivesShown
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CLOSE', _vm.lang)))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "evaobj",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addNewObjectivesToTest()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_ADD', _vm.lang)))])], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "centered": "",
      "size": "lg"
    },
    model: {
      value: (_vm.modalObjectiveSelectionShown),
      callback: function($$v) {
        _vm.modalObjectiveSelectionShown = $$v
      },
      expression: "modalObjectiveSelectionShown"
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n         " + _vm._s(_vm.$t('LNG_SELECT_AN_OBJECTIVE', _vm.lang)) + "\n       ")])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    ref: "objectifsListRef",
    attrs: {
      "options": _vm.objectifsList
    },
    model: {
      value: (_vm.selectedObjectiveInList),
      callback: function($$v) {
        _vm.selectedObjectiveInList = $$v
      },
      expression: "selectedObjectiveInList"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "pt-5",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n         " + _vm._s(_vm.$t('LNG_ADD_NEW_OBJECTIVE', _vm.lang)) + "\n       ")])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.newObjectiveText),
      callback: function($$v) {
        _vm.newObjectiveText = $$v
      },
      expression: "newObjectiveText"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.modalObjectiveSelectionShown = !_vm.modalObjectiveSelectionShown
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CLOSE', _vm.lang)))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "evaobj",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.affectObjective()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_ADD', _vm.lang)))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 878:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('LNG_DISCIPLINE_MANAGEMENT_TITLE', this.lang)))])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-client-table', {
    ref: "disciplinesTable",
    attrs: {
      "data": _vm.disciplinesData,
      "columns": _vm.disciplinesColumns,
      "options": _vm.disciplinesOptions
    },
    scopedSlots: _vm._u([{
      key: "disabled",
      fn: function(props) {
        return _c('div', {
          staticClass: "fa",
          class: {
            'fa-minus-circle': props.row.disabled === '1', 'fa-check-circle': props.row.disabled === '0'
          },
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.row.id)
            }
          }
        })
      }
    }, {
      key: "editDiscipline",
      fn: function(props) {
        return _c('div', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.disciplineRowClick(props)
            }
          }
        })
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "effect": "fade",
      "title": _vm.disciplineTitle
    },
    on: {
      "shown": _vm.setModalInputFocus
    },
    model: {
      value: (_vm.disciplineEditionModal),
      callback: function($$v) {
        _vm.disciplineEditionModal = $$v
      },
      expression: "disciplineEditionModal"
    }
  }, [(_vm.showDisciplineUpdateError) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n        " + _vm._s(this.updateDisciplineErrorMessage) + "\n     ")]) : _vm._e(), _vm._v(" "), _c('b-form', {
    on: {
      "submit": _vm.createUpdateNewDiscipline
    }
  }, [_c('b-form-input', {
    ref: "name",
    staticClass: "mb-3",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": _vm.$t('LNG_NAME_DISCIPLINE', this.lang)
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.selectYearGroup.options,
      "required": ""
    },
    model: {
      value: (_vm.selectYearGroup.value),
      callback: function($$v) {
        _vm.$set(_vm.selectYearGroup, "value", $$v)
      },
      expression: "selectYearGroup.value"
    }
  }), _vm._v(" "), _c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.selectLevelGroup.options,
      "required": ""
    },
    model: {
      value: (_vm.selectLevelGroup.value),
      callback: function($$v) {
        _vm.$set(_vm.selectLevelGroup, "value", $$v)
      },
      expression: "selectLevelGroup.value"
    }
  }), _vm._v(" "), (this.adminLevel & 4) ? _c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.selectCenterGroup.options,
      "required": ""
    },
    model: {
      value: (_vm.selectCenterGroup.value),
      callback: function($$v) {
        _vm.$set(_vm.selectCenterGroup, "value", $$v)
      },
      expression: "selectCenterGroup.value"
    }
  }) : _vm._e(), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exitNewDisciplineModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CLOSE', _vm.lang)))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "evaobj",
      "type": "submit"
    }
  }, [(this.selectedDiscipline === 0) ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('LNG_CREATE', this.lang)))]) : _vm._e(), (this.selectedDiscipline !== 0) ? _c('span', [_vm._v(_vm._s(_vm.$t('LNG_SAVE', this.lang)))]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 879:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "variant": "danger",
      "dismissible": ""
    },
    model: {
      value: (_vm.showErrorStatusChange),
      callback: function($$v) {
        _vm.showErrorStatusChange = $$v
      },
      expression: "showErrorStatusChange"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('LNG_ERROR', this.lang)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('LNG_TEACHER_STATUS_WAS_NOT_CHANGED', this.lang)))])]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('LNG_TEACHER_MANAGEMENT_TITLE', this.lang)))])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "cols": "2"
    }
  }, [_c('b-button', {
    staticClass: "btn btn-warning btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.importTeacher()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_IMPORT_TEACHER', this.lang)))])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-client-table', {
    ref: "teachersTable",
    attrs: {
      "data": _vm.teachersData,
      "columns": _vm.teachersColumns,
      "options": _vm.teachersOptions
    },
    scopedSlots: _vm._u([{
      key: "disabled",
      fn: function(props) {
        return _c('div', {
          staticClass: "fa",
          class: {
            'fa-minus-circle': props.row.disabled === '1', 'fa-check-circle': props.row.disabled === '0'
          },
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.row.id)
            }
          }
        })
      }
    }, {
      key: "editTeacher",
      fn: function(props) {
        return _c('div', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.teacherRowClick(props)
            }
          }
        })
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": _vm.addTeacherTitle,
      "effect": "fade"
    },
    on: {
      "shown": _vm.setModalInputFocus
    },
    model: {
      value: (_vm.teacherEditionModal),
      callback: function($$v) {
        _vm.teacherEditionModal = $$v
      },
      expression: "teacherEditionModal"
    }
  }, [(_vm.showTeacherUpdateError) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n          " + _vm._s(this.updateTeacherErrorMessage) + "\n       ")]) : _vm._e(), _vm._v(" "), _c('b-form', {
    on: {
      "submit": _vm.createUpdateNewTeacher
    }
  }, [_c('b-form-input', {
    ref: "name",
    staticClass: "mb-3",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": _vm.$t('LNG_NAME_TEACHER', this.lang)
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('b-form-input', {
    staticClass: "mb-3",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": _vm.$t('LNG_FIRSTNAME', this.lang)
    },
    model: {
      value: (_vm.firstname),
      callback: function($$v) {
        _vm.firstname = $$v
      },
      expression: "firstname"
    }
  }), _vm._v(" "), _c('b-form-input', {
    staticClass: "mb-3",
    attrs: {
      "type": "email",
      "required": "",
      "placeholder": _vm.$t('LNG_EMAIL', this.lang)
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), (this.adminLevel & 4) ? _c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.selectCenterGroup.options,
      "required": ""
    },
    model: {
      value: (_vm.selectCenterGroup.value),
      callback: function($$v) {
        _vm.$set(_vm.selectCenterGroup, "value", $$v)
      },
      expression: "selectCenterGroup.value"
    }
  }) : _vm._e(), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exitNewTeacherModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CLOSE', _vm.lang)))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "evaobj",
      "type": "submit"
    }
  }, [(this.selectedTeacher === 0) ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('LNG_CREATE', this.lang)))]) : _vm._e(), (this.selectedTeacher !== 0) ? _c('span', [_vm._v(_vm._s(_vm.$t('LNG_SAVE', this.lang)))]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "effect": "fade",
      "size": "lg"
    },
    model: {
      value: (_vm.fileModalTeachers),
      callback: function($$v) {
        _vm.fileModalTeachers = $$v
      },
      expression: "fileModalTeachers"
    }
  }, [(_vm.displayTeacherImportAlert) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('LNG_TEACHER_IMPORT_ERRORMESSAGE', this.lang, {
    importedTeachers: this.importedTeachers
  })) + " "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_TEACHER_IMPORT_ERRORMESSAGE_DETAILS', this.lang, {
    errorMessage: this.errorMessage
  })))])]) : _vm._e(), _vm._v(" "), (_vm.displayTeacherImportWarning) ? _c('div', {
    staticClass: "warning alert-warning",
    attrs: {
      "role": "warning"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('LNG_TEACHER_IMPORT_WARNINGMESSAGE', this.lang, {
    importedTeachers: this.importedTeachers
  })) + " "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_TEACHER_IMPORT_WARNINGMESSAGE_DETAILS', this.lang, {
    errorMessage: this.errorMessage
  })))])]) : _vm._e(), _vm._v(" "), (_vm.displayTeacherImportSuccess) ? _c('div', {
    staticClass: "success alert-success",
    attrs: {
      "role": "alert-success"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('LNG_TEACHER_IMPORT_SUCCESSMESSAGE', this.lang)) + " "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_TEACHER_IMPORT_SUCCESSMESSAGE_DETAILS', this.lang, {
    importedTeachers: this.importedTeachers
  })))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('LNG_SEND_A_FILE', this.lang)))])])]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b-form-checkbox', {
    attrs: {
      "true-value": "1"
    },
    model: {
      value: (_vm.teacherFileHasHeader),
      callback: function($$v) {
        _vm.teacherFileHasHeader = $$v
      },
      expression: "teacherFileHasHeader"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_TEACHER_SEND_A_FILE_WITH_HEADER', this.lang)))]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n     " + _vm._s(_vm.$t('LNG_TEACHER_FILE_DESCRIPTION', this.lang)) + "       \n     ")], 1), _vm._v(" "), _c('b-form', {
    on: {
      "submit": _vm.sendFileTeachers
    }
  }, [_c('b-form-file', {
    ref: "fileuploadteacher",
    attrs: {
      "accept": ".csv",
      "state": Boolean(_vm.teachersFile),
      "placeholder": _vm.$t('LNG_FILE', _vm.lang),
      "required": ""
    },
    model: {
      value: (_vm.teachersFile),
      callback: function($$v) {
        _vm.teachersFile = $$v
      },
      expression: "teachersFile"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "fileHelp"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_PLEASE_SELECT_A_FILE', this.lang)))])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exitFileModalTeacher()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CLOSE', _vm.lang)))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "evaobj",
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_SEND', this.lang)))])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 880:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "10",
      "offset": "1"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('LNG_BAREME_MANAGEMENT', this.lang)))])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "8",
      "offset": "2"
    }
  }, [_c('b-row', {
    staticClass: "syscoBox text-left"
  }, [_c('b-col', {
    staticClass: "text-white bg-evaobj pt-2",
    attrs: {
      "cols": "12",
      "id": "testContent"
    }
  }, [_c('h5', [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.$t('LNG_EVALUATION_INFORMATION', this.lang)))])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-3",
    attrs: {
      "cols": "12",
      "id": "testContent"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('LNG_NAME', this.lang)) + ": " + _vm._s(this.testName)), _c('br'), _vm._v(_vm._s(_vm.$t('LNG_DISCIPLINE', this.lang)) + ": " + _vm._s(this.testDiscipline)), _c('br'), _vm._v(_vm._s(_vm.$t('LNG_DATE', this.lang)) + ": " + _vm._s(_vm.testDateFormatted)), _c('br'), _c('br'), _vm._v("\n            " + _vm._s(_vm.$t('LNG_TOTAL_POINTS', this.lang)) + ": " + _vm._s(this.totalPoints) + " pts")])]), _vm._v(" "), (this.testComment !== '') ? _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('span', [_c('pre', [_vm._v(_vm._s(this.testComment))])])]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "1",
      "offset": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_GRADE', this.lang)))]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_MIN_POINTS', this.lang)))]), _vm._v(" "), _c('b-col', {
    staticClass: "text-left",
    attrs: {
      "cols": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_NUMBER_STUDENTS', this.lang)))])], 1), _vm._v(" "), _vm._l((_vm.bareme), function(b, indexe) {
    return _c('div', [_c('b-row', [_c('b-col', {
      attrs: {
        "cols": "1",
        "offset": "2"
      }
    }, [_vm._v(_vm._s(b.label))]), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "1"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "text",
        "placeholder": "Pts"
      },
      on: {
        "change": function($event) {
          return _vm.saveGrade(b, true)
        }
      },
      model: {
        value: (b.min),
        callback: function($$v) {
          _vm.$set(b, "min", $$v)
        },
        expression: "b.min"
      }
    })], 1), _vm._v(" "), _c('b-col', {
      staticClass: "text-left",
      attrs: {
        "cols": "2"
      }
    }, [(b.src1 !== '') ? _c('img', {
      staticClass: "tally",
      attrs: {
        "src": b.src1
      }
    }) : _vm._e(), _vm._v(" "), (b.src2 !== '') ? _c('img', {
      staticClass: "tally",
      attrs: {
        "src": b.src2
      }
    }) : _vm._e(), _vm._v(" "), (b.src3 !== '') ? _c('img', {
      staticClass: "tally",
      attrs: {
        "src": b.src3
      }
    }) : _vm._e(), _vm._v(" "), (b.src4 !== '') ? _c('img', {
      staticClass: "tally",
      attrs: {
        "src": b.src4
      }
    }) : _vm._e()])], 1)], 1)
  }), _vm._v(" "), _c('b-row', {
    staticClass: "mt-5"
  }, [_c('b-col', {
    attrs: {
      "cols": "3",
      "offset": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "type": "button",
      "variant": "evaobj",
      "block": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.printBareme('printSimpleBareme')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-print fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('LNG_PRINT', this.lang)))])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('b-button', {
    attrs: {
      "type": "button",
      "variant": "evaobj",
      "block": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.printBareme('printDetailedBareme')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-print fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('LNG_PRINT_DETAILLE', this.lang)))])], 1)], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 881:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "10",
      "offset": "1"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('LNG_STUDENT_MANAGEMENT_TITLE', this.lang)))])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "10",
      "offset": "1"
    }
  }, [_c('b-alert', {
    attrs: {
      "show": _vm.dismissCountDown,
      "variant": "success"
    },
    on: {
      "dismissed": function($event) {
        _vm.dismissCountdown = 0
      },
      "dismiss-count-down": _vm.countDownChanged
    }
  }, [_vm._v("\n         " + _vm._s(this.successMessage) + "\n        ")]), _vm._v(" "), _c('v-client-table', {
    ref: "studentsTable",
    attrs: {
      "data": _vm.studentsData,
      "columns": _vm.studentsColumns,
      "options": _vm.studentsOptions
    },
    scopedSlots: _vm._u([{
      key: "editStudent",
      fn: function(props) {
        return _c('div', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.studentRowClick(props)
            }
          }
        })
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "effect": "fade",
      "title": this.editBoxTitle
    },
    on: {
      "shown": _vm.setModalInputFocus
    },
    model: {
      value: (_vm.editStudent),
      callback: function($$v) {
        _vm.editStudent = $$v
      },
      expression: "editStudent"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": _vm.showMissingData
    }
  }, [_vm._v("    \n        " + _vm._s(_vm.$t('LNG_STUDENT_MISSING_DATA', this.lang)) + "\n    ")]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": _vm.showErrorMessage
    }
  }, [_vm._v("    \n        " + _vm._s(this.errorMessage) + "\n    ")]), _vm._v(" "), _c('b-input', {
    ref: "studentFirstname",
    staticClass: "mb-3",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": _vm.$t('LNG_STUDENT_FIRSTNAME', this.lang)
    },
    model: {
      value: (_vm.studentFirstname),
      callback: function($$v) {
        _vm.studentFirstname = $$v
      },
      expression: "studentFirstname"
    }
  }), _vm._v(" "), _c('b-input', {
    ref: "studentName",
    staticClass: "mb-3",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": _vm.$t('LNG_STUDENT_NAME', this.lang)
    },
    model: {
      value: (_vm.studentName),
      callback: function($$v) {
        _vm.studentName = $$v
      },
      expression: "studentName"
    }
  }), _vm._v(" "), _c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.selectSexe.options,
      "size": "sm"
    },
    model: {
      value: (_vm.selectSexe.value),
      callback: function($$v) {
        _vm.$set(_vm.selectSexe, "value", $$v)
      },
      expression: "selectSexe.value"
    }
  }), _vm._v(" "), _c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.selectEntity.options,
      "size": "sm"
    },
    model: {
      value: (_vm.selectEntity.value),
      callback: function($$v) {
        _vm.$set(_vm.selectEntity, "value", $$v)
      },
      expression: "selectEntity.value"
    }
  }), _vm._v(" "), _c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "multiple": "",
      "select-size": 4,
      "options": _vm.selectGroup.options
    },
    model: {
      value: (_vm.selectGroup.value),
      callback: function($$v) {
        _vm.$set(_vm.selectGroup, "value", $$v)
      },
      expression: "selectGroup.value"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exitEditStudent()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CLOSE', _vm.lang)))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "evaobj",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveEditStudent($event)
      }
    }
  }, [_vm._v(_vm._s(this.btnSaveStudent))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 882:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('b-img', {
    staticClass: "fixed-top",
    staticStyle: {
      "padding-top": "62px",
      "width": "30%"
    },
    attrs: {
      "src": _vm.imageSrcSpider,
      "fluid": ""
    }
  }), _vm._v(" "), (false) ? _c('div', [_c('a', {
    attrs: {
      "href": _vm.imageSrcKnowledge,
      "target": "_blank"
    }
  }, [_c('b-img', {
    attrs: {
      "src": _vm.imageSrcKnowledge,
      "fluid": ""
    }
  })], 1)]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('LNG_TEST', this.lang)) + " " + _vm._s(this.testName) + " " + _vm._s(this.testDiscipline))])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "text-left",
    attrs: {
      "cols": "8",
      "offset": "2"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.selectStudent.options
    },
    on: {
      "change": _vm.studentSelected
    },
    model: {
      value: (_vm.selectStudent.value),
      callback: function($$v) {
        _vm.$set(_vm.selectStudent, "value", $$v)
      },
      expression: "selectStudent.value"
    }
  })], 1)], 1), _vm._v(" "), (_vm.selectStudent.value != '' && _vm.selectStudent.value != undefined) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n            Total des points de l'élève: " + _vm._s(this.totalPointsStudent) + " / " + _vm._s(this.totalPoints) + "\n      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.selectStudent.value != '' && _vm.selectStudent.value != undefined) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "8",
      "offset": "2"
    }
  }, _vm._l((_vm.exercices), function(exercice, indexe) {
    return _c('div', [_c('b-row', {
      staticClass: "border pt-2 pb-2",
      class: {
        'selectedExercice': _vm.exerciceIsSelected[indexe]
      },
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.selectExercice(indexe, $event)
        }
      }
    }, [_c('b-col', {
      staticClass: "text-left",
      attrs: {
        "cols": "10"
      }
    }, [_vm._v(_vm._s(_vm.$t('LNG_EXERCICE', this.lang)) + " " + _vm._s(exercice.exoNumber) + " "), _c('i', {
      staticClass: "fa fa-2x",
      class: {
        'fa-sort-down': !_vm.exerciceIsShown[indexe], 'fa-sort-up': _vm.exerciceIsShown[indexe], 'align-top': !_vm.exerciceIsShown[indexe]
      },
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.toggleExercice($event, indexe)
        }
      }
    })]), _vm._v(" "), _c('b-col', {
      staticClass: "text-right",
      attrs: {
        "cols": "2"
      }
    }, [_vm._v(" " + _vm._s(_vm.totalByExoStudent[indexe]) + " / " + _vm._s(_vm.totalByExo[indexe]['points']) + " " + _vm._s(_vm.$t('LNG_PTS', this.lang)))])], 1), _vm._v(" "), _vm._l((exercice.parts), function(part, indexePart) {
      return _c('div', [_c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [_c('b-row', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.exerciceIsShown[indexe]),
          expression: "exerciceIsShown[indexe]"
        }]
      }, [_c('b-col', {
        staticClass: "text-left",
        class: {
          'selectedExercice': _vm.partIsSelected[indexe * 100 + indexePart]
        },
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "cols": "11",
          "offset": "1"
        }
      }, [_c('b-row', {
        staticClass: "border pt-2",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.selectPart(indexe, indexePart)
          }
        }
      }, [_c('b-col', {
        attrs: {
          "cols": "10"
        }
      }, [_vm._v(_vm._s(_vm.$t('LNG_PART', this.lang)) + " " + _vm._s(part.partName))]), _vm._v(" "), _c('b-col', {
        staticClass: "text-right",
        attrs: {
          "cols": "2"
        }
      }, [_vm._v(_vm._s(_vm.totalByPartStudent[indexe][_vm.partLetterToNumber(part.partName)]) + " / " + _vm._s(_vm.totalByExo[indexe]['parts'][part.partName]) + " " + _vm._s(_vm.$t('LNG_PTS', this.lang)))])], 1)], 1)], 1)], 1), _vm._v(" "), _vm._l((part.exercices), function(exo, indexeExo) {
        return _c('div', [_c('transition', {
          attrs: {
            "name": "fade"
          }
        }, [_c('b-row', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.exerciceIsShown[indexe]),
            expression: "exerciceIsShown[indexe]"
          }]
        }, [_c('b-col', {
          staticClass: "text-left",
          attrs: {
            "cols": "10",
            "offset": "2"
          }
        }, [_c('b-row', {
          staticClass: "pt-1",
          class: {
            'border-objectifLight': indexeExo % 2 !== 0, 'border-objectif': indexeExo % 2 === 0, 'objective-selected': _vm.objectiveIsSelected[exo.exoId]
          },
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.selectObjective(exo.exoId)
            }
          }
        }, [_c('b-col', {
          attrs: {
            "cols": "8"
          }
        }, [_vm._v(_vm._s(exo.obj))]), _vm._v(" "), _c('b-col', {
          staticClass: "pb-1 pt-1",
          attrs: {
            "cols": "2"
          }
        }, [_vm._v(_vm._s(exo.pts) + " pts")]), _vm._v(" "), _c('b-col', {
          staticClass: "pb-1 pt-1",
          attrs: {
            "cols": "2"
          }
        }, [_c('b-form-input', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.left",
            value: (_vm.$t('LNG_POINTS', this.lang)),
            expression: "$t('LNG_POINTS', this.lang)",
            modifiers: {
              "hover": true,
              "left": true
            }
          }],
          attrs: {
            "type": "text",
            "size": "sm"
          },
          on: {
            "change": function($event) {
              _vm.savePoints(exo.exoId, _vm.studentPoints[exercice.exoNumber][_vm.partLetterToNumber(part.partName)][exo.pos].pts)
            }
          },
          model: {
            value: (_vm.studentPoints[exercice.exoNumber][_vm.partLetterToNumber(part.partName)][exo.pos].pts),
            callback: function($$v) {
              _vm.$set(_vm.studentPoints[exercice.exoNumber][_vm.partLetterToNumber(part.partName)][exo.pos], "pts", $$v)
            },
            expression: "studentPoints[exercice.exoNumber][partLetterToNumber(part.partName)][exo.pos].pts"
          }
        })], 1)], 1), _vm._v(" "), _c('b-row', {
          staticClass: "pt-1"
        }, [_c('b-col', {
          staticClass: "pb-3"
        }, [_c('b-form-textarea', {
          attrs: {
            "type": "text",
            "rows": "2",
            "max-rows": "6"
          },
          on: {
            "change": function($event) {
              _vm.saveComments(exo.exoId, _vm.studentPoints[exercice.exoNumber][_vm.partLetterToNumber(part.partName)][exo.pos].comments)
            }
          },
          model: {
            value: (_vm.studentPoints[exercice.exoNumber][_vm.partLetterToNumber(part.partName)][exo.pos].comments),
            callback: function($$v) {
              _vm.$set(_vm.studentPoints[exercice.exoNumber][_vm.partLetterToNumber(part.partName)][exo.pos], "comments", $$v)
            },
            expression: "studentPoints[exercice.exoNumber][partLetterToNumber(part.partName)][exo.pos].comments"
          }
        })], 1)], 1)], 1)], 1)], 1)], 1)
      })], 2)
    })], 2)
  }), 0)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 883:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', [_c('b-alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.showErrorStatusChange),
      callback: function($$v) {
        _vm.showErrorStatusChange = $$v
      },
      expression: "showErrorStatusChange"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('LNG_ERROR', this.lang)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('LNG_STATUS_WAS_NOT_CHANGED', this.lang)))])]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('LNG_CENTER_MANAGEMENT_TITLE', this.lang)))])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-client-table', {
    ref: "centerTable",
    attrs: {
      "data": _vm.centersData,
      "columns": _vm.centersColumns,
      "options": _vm.centersOptions
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function(props) {
        return _c('div', {
          staticClass: "fa",
          class: {
            'fa-minus-circle': props.row.status === '1', 'fa-check-circle': props.row.status === '0'
          },
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.row.id)
            }
          }
        })
      }
    }, {
      key: "editCenter",
      fn: function(props) {
        return _c('div', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.centerRowClick(props)
            }
          }
        })
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "effect": "fade",
      "title": _vm.$t('LNG_NEW_CENTER', this.lang)
    },
    on: {
      "shown": _vm.setModalInputFocus
    },
    model: {
      value: (_vm.newCenterModal),
      callback: function($$v) {
        _vm.newCenterModal = $$v
      },
      expression: "newCenterModal"
    }
  }, [(_vm.showCenterUpdateError) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n         " + _vm._s(this.updateCenterErrorMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('b-input', {
    ref: "centerName",
    staticClass: "mb-3",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": _vm.$t('LNG_NAME_CENTER', this.lang)
    },
    model: {
      value: (_vm.centerName),
      callback: function($$v) {
        _vm.centerName = $$v
      },
      expression: "centerName"
    }
  }), _vm._v(" "), _c('b-input', {
    ref: "grade",
    attrs: {
      "type": "number",
      "required": "",
      "placeholder": _vm.$t('LNG_MAX_GRADE', this.lang)
    },
    model: {
      value: (_vm.grade),
      callback: function($$v) {
        _vm.grade = $$v
      },
      expression: "grade"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exitNewCenterModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CLOSE', _vm.lang)))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "evaobj",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createUpdateNewCenter($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnSaveText))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 884:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.showTop),
      callback: function($$v) {
        _vm.showTop = $$v
      },
      expression: "showTop"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('LNG_ERROR', this.lang)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('LNG_TEST_NOT_DELETED', this.lang)))])]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('LNG_MAINVIEW_TITLE', this.lang)))])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "10",
      "offset": "1"
    }
  }, [_c('div', {
    attrs: {
      "id": "tests"
    }
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.testData,
      "columns": _vm.testsColumns,
      "options": _vm.testsOptions
    },
    scopedSlots: _vm._u([{
      key: "editTest",
      fn: function(props) {
        return _c('div', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.editATest(props.row.id)
            }
          }
        })
      }
    }, {
      key: "deleteTest",
      fn: function(props) {
        return (props.row.shared !== 1) ? _c('div', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.deleteATest(props.row.id)
            }
          }
        }) : _vm._e()
      }
    }, {
      key: "wordButton",
      fn: function(props) {
        return (props.row.word) ? _c('div', {
          staticClass: "fa fa-file",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.openWord(props.row.id)
            }
          }
        }) : _vm._e()
      }
    }, {
      key: "pdfButton",
      fn: function(props) {
        return (props.row.pdf) ? _c('div', {
          staticClass: "fa fa-paperclip",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.openPdf(props.row.id)
            }
          }
        }) : _vm._e()
      }
    }, {
      key: "share",
      fn: function(props) {
        return (props.row.shared !== 1) ? _c('div', {
          staticClass: "fa fa-share-alt",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.openShareBox(props.row.id)
            }
          }
        }) : _vm._e()
      }
    }], true)
  })], 1)])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "effect": "fade",
      "title": _vm.$t('LNG_NEW_TEST', this.lang)
    },
    on: {
      "shown": _vm.setModalInputFocus
    },
    model: {
      value: (_vm.fileModalNewTest),
      callback: function($$v) {
        _vm.fileModalNewTest = $$v
      },
      expression: "fileModalNewTest"
    }
  }, [(_vm.showMissingDataError) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(this.missingDataErrorMsg))]) : _vm._e(), _vm._v(" "), _c('b-form-input', {
    ref: "testName",
    staticClass: "mb-3",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": _vm.$t('LNG_NAME', this.lang)
    },
    model: {
      value: (_vm.testName),
      callback: function($$v) {
        _vm.testName = $$v
      },
      expression: "testName"
    }
  }), _vm._v(" "), _c('b-form-input', {
    staticClass: "mb-3",
    attrs: {
      "type": "date",
      "placeholder": _vm.$t('LNG_DATE', this.lang)
    },
    model: {
      value: (_vm.testDate),
      callback: function($$v) {
        _vm.testDate = $$v
      },
      expression: "testDate"
    }
  }), _vm._v(" "), _c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.selectDiscipline.options
    },
    model: {
      value: (_vm.selectDiscipline.value),
      callback: function($$v) {
        _vm.$set(_vm.selectDiscipline, "value", $$v)
      },
      expression: "selectDiscipline.value"
    }
  }, [_c('template', {
    slot: "first"
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("-- " + _vm._s(_vm.$t('LNG_SELECT_DISCIPLINE_DEFAULT', this.lang)) + " --")])])], 2), _vm._v(" "), _c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "multiple": "",
      "options": _vm.selectTestGroup.options
    },
    model: {
      value: (_vm.selectTestGroup.value),
      callback: function($$v) {
        _vm.$set(_vm.selectTestGroup, "value", $$v)
      },
      expression: "selectTestGroup.value"
    }
  }), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "rows": "5",
      "id": "comment",
      "placeholder": _vm.$t('LNG_TEST_COMMENTS', this.lang)
    },
    model: {
      value: (_vm.comment),
      callback: function($$v) {
        _vm.comment = $$v
      },
      expression: "comment"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exitFileModalNewTest()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CLOSE', _vm.lang)))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "evaobj",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createNewTest($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CREATE', _vm.lang)))])], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "effect": "fade"
    },
    model: {
      value: (_vm.fileModalShareTest),
      callback: function($$v) {
        _vm.fileModalShareTest = $$v
      },
      expression: "fileModalShareTest"
    }
  }, [(_vm.showErrorSharedStatusChange) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('LNG_ERROR_UPDATING_SHARING_STATUS', this.lang)) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('LNG_MANAGE_SHARING', this.lang)))])])]), _vm._v(" "), _c('v-client-table', {
    attrs: {
      "data": _vm.teacherSharedData,
      "columns": _vm.teacherSharedColumns,
      "options": _vm.teacherSharedOptions
    },
    scopedSlots: _vm._u([{
      key: "shared",
      fn: function(props) {
        return _c('div', {
          staticClass: "fa",
          class: {
            'fa-check': props.row.shared === '1', 'fa-minus-circle': (props.row.shared === null || props.row.shared === '0')
          },
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.changeSharedStatus(props.row.id)
            }
          }
        })
      }
    }, {
      key: "can_edit",
      fn: function(props) {
        return (props.row.shared === '1') ? _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (false),
            expression: "false"
          }],
          staticClass: "fa"
        }, [_c('b-form-checkbox', {
          on: {
            "change": function($event) {
              return _vm.editModeClicked(props.row.id)
            }
          },
          model: {
            value: (_vm.canEditArray[props.row.id]),
            callback: function($$v) {
              _vm.$set(_vm.canEditArray, props.row.id, $$v)
            },
            expression: "canEditArray[props.row.id]"
          }
        })], 1) : _vm._e()
      }
    }], true)
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exitModalShareTest()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CLOSE', this.lang)))])])], 1), _vm._v(" "), _c('b-alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.showAlertNoLicence),
      callback: function($$v) {
        _vm.showAlertNoLicence = $$v
      },
      expression: "showAlertNoLicence"
    }
  }, [_c('span', {
    staticClass: "icon-ok-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('LNG_WARNING_VERSION', this.lang)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('LNG_YOU_USE_THE_FREE_VERSION', this.lang)))])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": _vm.$t('LNG_CONFIRM_TEST_DELETION', this.lang),
      "cancel-title": _vm.$t('LNG_CANCEL', this.lang),
      "ok-variant": "evaobj",
      "ok-title": _vm.$t('LNG_DELETE', this.lang)
    },
    on: {
      "ok": _vm.okDeleteTestAction,
      "cancel": _vm.cancelAction
    },
    model: {
      value: (_vm.showDeleteModal),
      callback: function($$v) {
        _vm.showDeleteModal = $$v
      },
      expression: "showDeleteModal"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('LNG_DO_YOU_REALLY_WANT_TO_DELETE_THE_TEST', this.lang)) + "\n    ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": _vm.$t('LNG_SEND_A_FILE', this.lang),
      "size": "lg"
    },
    model: {
      value: (_vm.fileModalStudents),
      callback: function($$v) {
        _vm.fileModalStudents = $$v
      },
      expression: "fileModalStudents"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger"
    },
    model: {
      value: (_vm.displayStudentImportAlert),
      callback: function($$v) {
        _vm.displayStudentImportAlert = $$v
      },
      expression: "displayStudentImportAlert"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('LNG_STUDENT_IMPORT_WARNING', this.lang, {
    importedStudents: this.importedStudents
  })) + " "), _c('br'), _vm._v("\n          " + _vm._s(_vm.$t('LNG_STUDENT_IMPORT_ERRORMESSAGE', this.lang, {
    errorMessage: this.errorMessage
  })) + "\n      ")]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "warning"
    },
    model: {
      value: (_vm.displayStudentImportWarning),
      callback: function($$v) {
        _vm.displayStudentImportWarning = $$v
      },
      expression: "displayStudentImportWarning"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('LNG_STUDENT_IMPORT_WARNING', this.lang, {
    importedStudents: this.importedStudents
  })) + " "), _c('br'), _vm._v("\n          " + _vm._s(_vm.$t('LNG_STUDENT_IMPORT_ERRORMESSAGE', this.lang, {
    errorMessage: this.errorMessage
  })) + "\n       ")]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "success"
    },
    model: {
      value: (_vm.displayStudentImportSuccess),
      callback: function($$v) {
        _vm.displayStudentImportSuccess = $$v
      },
      expression: "displayStudentImportSuccess"
    }
  }, [_vm._v("\n         " + _vm._s(_vm.$t('LNG_STUDENT_IMPORT_SUCCESS', this.lang, {
    number: this.importedStudents
  })) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": "1"
    },
    model: {
      value: (_vm.studentFileHasHeader),
      callback: function($$v) {
        _vm.studentFileHasHeader = $$v
      },
      expression: "studentFileHasHeader"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_STUDENT_SEND_A_FILE_WITH_HEADER', this.lang)))])], 1), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.$t('LNG_STUDENT_FILE_DESCRIPTION', this.lang)))]), _vm._v(" "), _c('b-form-file', {
    ref: "fileinput",
    attrs: {
      "accept": ".csv",
      "state": Boolean(_vm.studentFile),
      "placeholder": _vm.$t('LNG_FILE', _vm.lang),
      "required": ""
    },
    model: {
      value: (_vm.studentFile),
      callback: function($$v) {
        _vm.studentFile = $$v
      },
      expression: "studentFile"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exitFileModalStudents()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CLOSE', _vm.lang)))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "evaobj",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendFileStudents($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CREATE', _vm.lang)))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 885:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recoverPassword container-fluid"
  }, [_c('b-alert', {
    attrs: {
      "show": _vm.errorAlertShown,
      "dismissible": "",
      "variant": "danger"
    },
    on: {
      "dismissed": function($event) {
        _vm.errorAlertShown = 0
      },
      "dismiss-count-down": _vm.countDownChanged
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('LNG_ERROR_SENDING_NEW_PASSWORD', this.lang)))])]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "show": _vm.showSuccess,
      "dismissible": "",
      "variant": "evaobj"
    },
    on: {
      "dismissed": function($event) {
        _vm.showSuccess = 0
      },
      "dismiss-count-down": _vm.countDownChanged
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('LNG_NEW_PASSWORD_SENT', this.lang)))])]), _vm._v(" "), _c('b-form', {
    on: {
      "submit": _vm.recoverPassword
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('img', {
    attrs: {
      "title": _vm.$t('LNG_TITLE', this.lang),
      "alt": _vm.$t('LNG_TITLE', this.lang),
      "width": "200px",
      "src": __webpack_require__(148)
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('LNG_TITLE_RECOVER_PASSWORD', _vm.lang)))])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "my-1"
  }, [_c('b-col', {
    attrs: {
      "sm": "3",
      "lg": "4"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "4"
    }
  }, [_c('b-input-group', [_c('b-input-group-text', {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-user"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email",
      "placeholder": _vm.$t('LNG_EMAIL', _vm.lang),
      "required": "",
      "autofocus": "",
      "autocapitalize": "off"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "my-3"
  }, [_c('b-col', {
    attrs: {
      "sm": "3",
      "lg": "4"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "4"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "evaobj",
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_RECOVER_PASSWORD', _vm.lang)))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

},[434]);


// WEBPACK FOOTER //
// static/js/app.606e1715d710b762f13f.js